import React, { useContext, useEffect, useRef, useState } from "react";
import {
  HTTPResponse,
  SideMenuItems,
  ToastMessageType,
  ToastMessages,
  Values,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import DateControl from "../../Components/DateControl";
import { AppContext } from "../../Contexts/AppContextProvider";
import {
  AdjustDays,

  AllowNumberWithTwoDecimal,
  DateValid,
  DisplayFormat,
  GetLocalStorageData,
  GetLoggedInUserID,
  GetOrdinal,
  IsAdmin,
  IsDateEmpty,

  IsGreaterOrEqual,


  applySidebarState,
  isStringEmpty,
  toggleSidebar,
} from "../../Helpers/Utilities";
import InfoPopUp from "../../Components/InfoPopUp";
import {
  CommonError_Msgs,
  hyperlinkTextCombinedLKT,
  hyperlinkTextSequentialLKT,
  hyperlinkTextTransplantVisits,
} from "../../Helpers/HelperText";
import { TransplantCharacteristicService } from "../../WebApiServices/TransplantCharacteristicService";
import ErrorField from "../../Components/ErrorField";
import CustomTextArea from "../../Components/CustomTextArea ";

const TransplantCharacteristics = () => {
  const navigatePaths = {
    prevPage: "/ClinicalCharacteristics",
    currPage: "/ TransplantCharacteristics",
    nextPage: "/MDEInfo",
  };



  let dates = GetLocalStorageData("ClinicalCharacteristicsDates");
  
  const[transplantAdmissionHospDate,setTransplantAdmissionHospDate] = useState(null);
  const[transplantDisDate,setTransplantDisDate] = useState(null);
  const pidRef = useRef(0);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setisSideMenuActive,
    ShowActionPopUp
  } = useContext(AppContext);

  const [
    showHideHyperlinkModalSequential,
    setShowHideHyperlinkModalSequential,
  ] = useState(false);
  const [showHideHyperlinkModal, setShowHideHyperlinkModal] = useState(false);
  const [showHideHyperlinkModalTransplantVisit, setShowHideHyperlinkModalTransplantVisit] = useState(false);

  const [lkt_value, setLKTValue] = useState(null);
  const [lt_selected, setLTSelected] = useState(false);
  const [patientLocked, setpatientLocked] = useState(false);
  const InitialHardErrList = {
    //17 admission
    transplant_admission_empty: false,
    transplant_admission_dt_empty: false,
    transplant_admission_dt_invalid: false,

    //discharge
    transplant_discharge_empty: false,
    transplant_discharge_dt_empty: false,
    transplant_discharge_dt_invalid: false,

    earliest_lt_lkt_dt_Invalid: false,
    latest_lt_lkt_Invalid:false,

    //18
    rbl_donor_statusEmpty: false,
    rbl_donor_disease_histEmpty: false,
    rbl_donor_relationEmpty: false,
    rbl_state_organ_rcvdEmpty: false,
    rbl_auxillary_transplantEmpty: false,
    rbl_lobe_rcvdEmpty: false,

    //19
    rbl_liver_graft_weightEmpty: false,
    rbl_liver_graft_weight_valueEmpty: false,
    rbl_liver_graft_weight_invalid: false,

    //20
    indicate_LT_ProcedureEmpty: false,

    //21
    renal_replacementEmpty: false,

    //22
    liver_recipientEmpty: false,
    liver_donorEmpty: false,

    //23
    transplant_post_operative_complicationsEmpty: false,
  };

  const [hardErrList, setHardErrList] = useState(InitialHardErrList);

  const [newClosestoneYrpriorIndex, setClosestoneYrpriorIndex] = useState("");
  const [most_newClosest_threeMonthAfterIndex, setnewClosest_threeMonthAfterIndex] = useState("");

  const[transplantAdDatechangeCount,setTransplantAdDatechangeCount] = useState(false);
  const[transplantDisDatechangeCount,setTransplantDisDatechangeCount] = useState(false);

  const [transplantDetails, setTransplantDetails] = useState({
    //17 admission

    transplant_admission_dt: null,


    //17 discharge

    transplant_discharge_dt: null,
 

    //18 col 1
    rbl_donor_status: null,
    rbl_donor_disease_hist: null,
    rbl_donor_relation: null,
    rbl_state_organ_rcvd: null,
    rbl_auxillary_transplant: null,
    rbl_lobe_rcvd: null,

    //19
    rbl_liver_graft_weight: null,
    liver_graft_weight_value_oz: "",
    liver_graft_weight_value_lbs: "",
    liver_graft_weight_value_g: "",
    liver_graft_weight_value_kg: "",

    //20
    chk_primary_abdominal_closure: false,
    chk_induction_immunosuppression_therapy: false,
    rbl_lt_procedure_none_Unk: null,

    //21
    chk_hemodialysis: false,
    chk_hemodiafiltration_hemofiltration: false,
    chk_peritoneal_dialysis: false,
    rbl_renal_replacement_none_unk: null,

    //22 receipant
    chk_liver_recipient_EBV: false,
    chk_liver_recipient_CMV: false,
    rbl_liver_recipient_none_Unk: null,

    //donor
    chk_liver_donor_EBV: false,
    chk_liver_donor_CMV: false,
    rbl_liver_donor_none_Unk: null,

    //23
    chk_acute_lactic_acidosis: false,
    chk_bile_leak: false,
    chk_thrombosis: false,
    chk_portal_vein_thrombosis: false,
    chk_hepatic_artery_thrombosis: false,
    rbl_type_thrombosis_unknown: null,
    chk_transfusion_operative_intervention: false,
    chk_stricture: false,
    chk_biliary_stricture: false,
    chk_portal_vein_stricture: false,
    chk_hepatic_artery_stricture: false,
    chk_hepatic_vein_stricture: false,
    rbl_type_stricture_unknown: null,
    chk_infection: false,
    chk_bacteremia_bloodstream_infection: false,
    chk_abdominal_wound_infection: false,
    chk_pneumonia_infection: false,
    chk_epstein_barr_virus_infection: false,
    chk_cytomegalovirus_infection: false,
    rbl_type_infection_unknown: null,
    chk_post_operative_complications_other: false,
    txt_post_operative_complications: "",
    rbl_post_operative_none_of_the_above: null,
  });

  const TransplantVisitRow = {
    transplantvisitid: 0, // pk of child table
    transplantcharacteristicsid: 0,

    //24 admission
    rbl_transplant_visit_admission: null,
    transplant_visit_admission_dt: null,
    chk_transplant_visit_admission_est: false,

    //discharge
    rbl_transplant_visit_discharge: null,
    transplant_visit_discharge_dt: null,
    chk_transplant_visit_discharge_est: false,

    //visit type
    rbl_visit_type: null,

    //validations - admission
    transplant_visit_admissionEmpty: false,
    transplant_admission_visit_dt_empty: false,
    transplant_admission_visit_dt_invalid: false,

    // validations discharge
    transplant_visit_dischargeEmpty: false,
    transplant_discharge_visit_dt_empty: false,
    transplant_discharge_visit_dt_invalid: false,

    //validations visit type
    visit_typeEmpty: false,
  };

  const [transplantVisitDetails, setTransplantVisitDetails] = useState([
    TransplantVisitRow,
  ]);






  const TransplantRelatedHospRow = {
    transplantltlktid: 0, // pk of child table
    transplantcharacteristicsid: 0,

    //24 admission
    rbl_transplant_lt_lkt_admission: null,
    transplant_lt_lkt_admission_dt: null,
    chk_transplant_lt_lkt_admission_est: false,

    //discharge
    rbl_transplant_lt_lkt_discharge: null,
    transplant_lt_lkt_discharge_dt: null,
    chk_transplant_lt_lkt_discharge_est: false,

    //visit type
    rbl_lt_lkt_visit_type: null,

    //validations - admission
    transplant_lt_lkt_admissionEmpty: false,
    transplant_admission_lt_lkt_dt_empty: false,
    transplant_admission_lt_lkt_dt_invalid: false,

    // validations discharge
    transplant_lt_lkt_dischargeEmpty: false,
    transplant_discharge_lt_lkt_dt_empty: false,
    transplant_discharge_lt_lkt_dt_invalid: false,

    //validations visit type
    lt_lkt_visit_typeEmpty: false,
  };
  const [transplantRelatedHospitalization, setTransplantRelatedHospitalization] = useState([
    TransplantRelatedHospRow,
  ]);

  const TransplantRejectionRow = {
    transplantrejectionid: 0, // pk of child table
    // transplantcharacteristicsid:0,

    //25 LT rejection start date
    rbl_transplant_rejection_start: null,
    transplant_rejection_start_dt: null,
    chk_transplant_rejection_start_est: false,

    //Rejection episode end date
    rbl_transplant_rejection_end: null,
    transplant_rejection_end_dt: null,
    chk_transplant_rejection_end_est: false,

    //Type of rejection
    rbl_rejection_type: null,

    //validations - rejection start
    transplant_rejection_startEmpty: false,
    transplant_rejection_start_dt_empty: false,
    transplant_rejection_start_dt_invalid: false,

    // validations end date
    transplant_rejection_endEmpty: false,
    transplant_rejection_end_dt_empty: false,
    transplant_rejection_end_dt_invalid: false,

    //validations rejection type
    rejection_typeEmpty: false,
  };
  const [transplantRejectionDetails, setTransplantRejectionDetails] = useState([
    TransplantRejectionRow,
  ]);



  const TransplantHospitalizationRow = {
    transplanthospitalizationid: 0, // pk of child table


    //26 Date of transplant
    rbl_transplant_hospitalization: null,
    transplant_hospitalization_dt: null,
    chk_transplant_hospitalization_est: false,



    //26 Kidney transplant hospitalization admission date 
    rbl_transplant_kidney_admission: null,
    transplant_kidney_admission_dt: null,
    chk_transplant_kidney_admission_est: false,



    //26 Kidney transplant hospitalization discharge date
    rbl_transplant_kidney_discharge: null,
    transplant_kidney_discharge_dt: null,
    chk_transplant_kidney_discharge_est: false,


    //Part of LKT
    rbl_part_lkt: null,

    //Donor type
    rbl_donor_type: null,

    //Procedure type
    rbl_procedure_type: null,

    //kidney location 
    rbl_kidney_location: null,



    //validations - hosp col 1
    rbl_transplant_hospitalizationEmpty: false,
    transplant_hospitalization_dt_empty: false,
    transplant_hospitalization_dt_invalid: false,

    // validations - admission col 2
    transplant_kidney_admissionEmpty: false,
    transplant_kidney_admission_dt_empty: false,
    transplant_kidney_admission_dt_invalid: false,


    // validations - discharge col 3 
    transplant_kidney_dischargeEmpty: false,
    transplant_kidney_discharge_dt_empty: false,
    transplant_kidney_discharge_dt_invalid: false,

    //validations 
    part_lktEmpty: false,

    //Donor type
    transplant_donor_typeEmpty: null,

    //Procedure type
    transplant_procedure_typeEmpty: null,

    //kidney location 
    transplant_kidney_locationEmpty: null,

  };
  const [transplantHospitalizationDetails, setTransplantHospitalizationDetails] = useState([
    TransplantHospitalizationRow,
  ]);

  async function LoadData() {
    try {
      const response = await TransplantCharacteristicService.LoadData(
        pidRef.current
      );
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;
        setpatientLocked(data.patientLocked);
        SetFields(data);
        //  setLKTSelected(data.lkT_Selected === true ? true : false)
        setLKTValue(data.liverKidneyValue);
        setLTSelected(data.lT_Selected);
        setTransplantAdmissionHospDate( data.earliestTransplantLtktAdmissionDate || dates.transplant_admissionDt);
        setTransplantDisDate(data.latestTransplantLtktDischargeDate || dates.transplant_dischargeDt );
      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else {
          throw response.error;
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
    return null;
  }

  const SetFields = (data) => {



    setTransplantDetails((prev) => {
      return {
        ...prev,

        //17admission
        transplant_admission_dt: data.hospitalAdmissionDate || null,

        //17discharge
        transplant_discharge_dt: data.hospitalDischargeDate || null,

        //18
        rbl_donor_status: data.donorStatus,
        rbl_donor_disease_hist: data.donorHistoryDisease,
        rbl_donor_relation: data.donorRelationPatient,
        rbl_state_organ_rcvd: data.organReceived,
        rbl_auxillary_transplant: data.auxillaryTransplant,
        rbl_lobe_rcvd: data.lobeReceived,

        //19
        rbl_liver_graft_weight: data.liverGraftWeight,
        liver_graft_weight_value_oz:
          data.liverGraftWeight === 1 ? data.liverGraftWeightValue : "",

        liver_graft_weight_value_lbs:
          data.liverGraftWeight === 2 ? data.liverGraftWeightValue : "",

        liver_graft_weight_value_g:
          data.liverGraftWeight === 3 ? data.liverGraftWeightValue : "",

        liver_graft_weight_value_kg:
          data.liverGraftWeight === 4 ? data.liverGraftWeightValue : "",

        //20
        chk_primary_abdominal_closure: data.ltProcedureAbdominalClosure,
        chk_induction_immunosuppression_therapy:
          data.ltProcedureImmunosuppressionTherapy,
        rbl_lt_procedure_none_Unk: data.ltProcedureNoneUnknown,

        //21
        chk_hemodialysis: data.renalReplacementHemodialysis,
        chk_hemodiafiltration_hemofiltration:
          data.renalReplacementHemodiafilteration,
        chk_peritoneal_dialysis: data.renalReplacementPeritonealDialysis,
        rbl_renal_replacement_none_unk: data.renalReplacementNoneUnknown,

        //22
        chk_liver_recipient_EBV: data.liverReceipientEbv,
        chk_liver_recipient_CMV: data.liverReceipientCmv,
        rbl_liver_recipient_none_Unk: data.liverReceipientNoneUnknown,

        //donor
        chk_liver_donor_EBV: data.liverDonorEbv,
        chk_liver_donor_CMV: data.liverDonorCmv,
        rbl_liver_donor_none_Unk: data.liverDonorNoneUnknown,

        //23
        chk_acute_lactic_acidosis: data.transplantPostoperationAcutelactic,
        chk_bile_leak: data.transplantPostoperationBileLeak,
        chk_thrombosis: data.transplantPostoperationThrombosis,
        chk_portal_vein_thrombosis: data.transplantPostoperationVeinThrombosis,
        chk_hepatic_artery_thrombosis:
          data.transplantPostoperationArteryThrombosis,
        rbl_type_thrombosis_unknown:
          data.transplantPostoperationThrombosisUnknown,
        chk_transfusion_operative_intervention:
          data.transplantPostoperationBleeding,
        chk_stricture: data.transplantPostoperationStricture,
        chk_biliary_stricture: data.transplantPostoperationBiliaryStricture,
        chk_portal_vein_stricture: data.transplantPostoperationVeinStricture,
        chk_hepatic_artery_stricture:
          data.transplantPostoperationArteryStricture,
        chk_hepatic_vein_stricture: data.transplantPostoperationHepaticVein,
        rbl_type_stricture_unknown:
          data.transplantPostoperationStrictureUnknown,
        chk_infection: data.transplantPostoperationInfection,
        chk_bacteremia_bloodstream_infection:
          data.transplantPostoperationBacteremia,
        chk_abdominal_wound_infection: data.transplantPostoperationAbdominal,
        chk_pneumonia_infection: data.transplantPostoperationPneumonia,
        chk_epstein_barr_virus_infection: data.transplantPostoperationEbv,
        chk_cytomegalovirus_infection: data.transplantPostoperationCmv,
        rbl_type_infection_unknown:
          data.transplantPostoperationInfectionUnknown,
        chk_post_operative_complications_other:
          data.transplantPostoperationOther,
        txt_post_operative_complications: data.transplantPostoperationOtherTxt,
        rbl_post_operative_none_of_the_above: data.transplantPostoperationNone,
      };
    });



// transplant ltkt related hospitalization
if (
  data.transplantLtktData !== null &&
  data.transplantLtktData.length > 0
) {
  const { transplantLtktData } = data;
  const transplantLtktDetailsArray = transplantLtktData.map((item) => {
    const transplantltlktid =
      item.transplantltlkthospitalizationsid !== null ? item.transplantltlkthospitalizationsid : 0;

    const rbl_transplant_lt_lkt_admission =
      item.ltlktAdmission !== null ? item.ltlktAdmission : null;

    const transplant_lt_lkt_admission_dt = !isStringEmpty(
      item.ltlktAdmissionDate
    )
      ? item.ltlktAdmissionDate
      : null;




    return {
      ...TransplantRelatedHospRow,
      transplantltlktid,
      rbl_transplant_lt_lkt_admission,
      transplant_lt_lkt_admission_dt,
      chk_transplant_lt_lkt_admission_est: item.ltlktAdmissionDateEstimated,

      rbl_transplant_lt_lkt_discharge: item.ltlktDischarge,
      transplant_lt_lkt_discharge_dt: !isStringEmpty(item.ltlktDischargeDate)?item.ltlktDischargeDate:null,
      chk_transplant_lt_lkt_discharge_est: item.ltlktDischargeDateEstimated,
      rbl_lt_lkt_visit_type: item.visitType,
    };
  });
  setTransplantRelatedHospitalization(transplantLtktDetailsArray);
}





    if (
      data.transplantVisitData !== null &&
      data.transplantVisitData.length > 0
    ) {
      const { transplantVisitData } = data;
      const transplantvisitDetailsArray = transplantVisitData.map((item) => {
        const transplantvisitid =
          item.transplantvisitid !== null ? item.transplantvisitid : 0;

        const rbl_transplant_visit_admission =
          item.admissionVisit !== null ? item.admissionVisit : null;

        const transplant_visit_admission_dt = !isStringEmpty(
          item.admissionVisitDate
        )
          ? item.admissionVisitDate
          : null;

        return {
          ...TransplantVisitRow,
          transplantvisitid,
          rbl_transplant_visit_admission,
          transplant_visit_admission_dt,
          chk_transplant_visit_admission_est: item.admissionVisitDateEstimated,

          rbl_transplant_visit_discharge: item.dischargeVisit,
          transplant_visit_discharge_dt: !isStringEmpty(item.dischargeVisitDate)? item.dischargeVisitDate: null,
          chk_transplant_visit_discharge_est: item.dischargeVisitDateEstimated,
          rbl_visit_type: item.visitType,
        };
      });
      setTransplantVisitDetails(transplantvisitDetailsArray);
    }

    // Rejection episode
    if (
      data.transplantRejectionData !== null &&
      data.transplantRejectionData.length > 0
    ) {
      const { transplantRejectionData } = data;
      const transplantRejectionDetailsArray = transplantRejectionData.map(
        (item) => {
          const transplantrejectionid =
            item.transplantrejectionid !== null ? item.transplantrejectionid : 0;

          const rbl_transplant_rejection_start =
            item.rejectionEpisodeStart !== null
              ? item.rejectionEpisodeStart
              : null;

          const transplant_rejection_start_dt = !isStringEmpty(
            item.rejectionEpisodeStartDate
          )
            ? item.rejectionEpisodeStartDate
            : null;

          return {
            ...TransplantRejectionRow,
            transplantrejectionid,
            rbl_transplant_rejection_start,
            transplant_rejection_start_dt,

            chk_transplant_rejection_start_est:
              item.rejectionEpisodeStartDateEstimated,

            rbl_transplant_rejection_end: item.rejectionEpisodeEnd,
            transplant_rejection_end_dt: !isStringEmpty(item.rejectionEpisodeEndDate)?item.rejectionEpisodeEndDate:null,
            chk_transplant_rejection_end_est:
              item.rejectionEpisodeEndDateEstimated,

            rbl_rejection_type: item.rejectionType,
          };
        }
      );
      setTransplantRejectionDetails(transplantRejectionDetailsArray);
    }

    if (
      data.transplantHospitalizationsData !== null &&
      data.transplantHospitalizationsData.length > 0
    ) {
      const { transplantHospitalizationsData } = data;
      const transplantHospitalizationDetailsArray = transplantHospitalizationsData.map(
        (item) => {

          const transplanthospitalizationid =
            item.transplanthospitalizationid !== null ? item.transplanthospitalizationid : 0;



          const rbl_transplant_hospitalization =
            item.kidneyTransplant !== null
              ? item.kidneyTransplant
              : null;

          const transplant_hospitalization_dt = !isStringEmpty(
            item.kidneyTransplantDate
          )
            ? item.kidneyTransplantDate
            : null;



          const rbl_transplant_kidney_admission =
            item.kidneyTransplantAdmission !== null
              ? item.kidneyTransplantAdmission
              : null;

          const transplant_kidney_admission_dt = !isStringEmpty(
            item.kidneyTransplantAdmissionDate
          )
            ? item.kidneyTransplantAdmissionDate
            : null;


          const rbl_transplant_kidney_discharge =
            item.kidneyTransplantDischarge !== null
              ? item.kidneyTransplantDischarge
              : null;

          const transplant_kidney_discharge_dt = !isStringEmpty(
            item.kidneyTransplantDischargeDate
          )
            ? item.kidneyTransplantDischargeDate
            : null;

          return {
            ...TransplantHospitalizationRow,
            transplanthospitalizationid,
            rbl_transplant_hospitalization,
            transplant_hospitalization_dt,
            chk_transplant_hospitalization_est: item.kidneyTransplantDateEstimated,

            rbl_transplant_kidney_admission,
            transplant_kidney_admission_dt,
            chk_transplant_kidney_admission_est: item.kidneyTransplantAdmissionDateEstimated,



            rbl_transplant_kidney_discharge,
            transplant_kidney_discharge_dt,
            chk_transplant_kidney_discharge_est: item.kidneyTransplantDischargeDateEstimated,

            rbl_part_lkt: item.partLkt,
            rbl_donor_type: item.donorType,
            rbl_procedure_type: item.procedureType,
            rbl_kidney_location: item.kidneyLocation

          };
        }
      );
      setTransplantHospitalizationDetails(transplantHospitalizationDetailsArray);
    }



  };

  const SavePage = async (validate) => {
      try {
          if (!patientLocked) {
              //Reset Errors
              setHardErrList(InitialHardErrList);
              let isValid = validate ? Validate() : true;
              if (!isValid) {
                  setShowTopErrMsg(true);
                  return false;
              }
              setShowTopErrMsg(false);

              let updatedArray = [...transplantRelatedHospitalization];
              const validDates = updatedArray
                  .map(entry => entry.transplant_lt_lkt_admission_dt)
                  .filter(d => d);

              const earliestDate = validDates.length > 0 ? new Date(Math.min(...validDates.map(d => new Date(d)))) : null;

              let formattedDateAdmission = DisplayFormat(earliestDate)



              const validDate = updatedArray
                  .map(entry => entry.transplant_lt_lkt_discharge_dt)
                  .filter(d => d);

              const latestDate = validDate.length > 0
                  ? new Date(Math.max(...validDate.map(d => new Date(d))))
                  : null;

              let formattedDateDis = DisplayFormat(latestDate)

              let transplantAdmissionMinusOne = AdjustDays(formattedDateAdmission, -Values.value1);//dates.transplant_admissionDt
              let transplantDischargePlusOne = AdjustDays(formattedDateDis, Values.value1); //dates.transplant_dischargeDt

              let most_ClosestoneYrpriorIndex = false;
              most_ClosestoneYrpriorIndex = DateValid(dates.beginning_follow_up, transplantAdmissionMinusOne);

              let most_Closest_threemonths = false;
              most_Closest_threemonths = IsGreaterOrEqual(dates.endofFollowUpDate, transplantDischargePlusOne);





              //17
              const transplantLtktData = transplantRelatedHospitalization.map((test) => ({
                  Transplantltlkthospitalizationsid: test.transplantltlktid,

                  LtlktAdmission: test.rbl_transplant_lt_lkt_admission,
                  LtlktAdmissionDate: test.transplant_lt_lkt_admission_dt,
                  LtlktAdmissionDateEstimated: test.chk_transplant_lt_lkt_admission_est,

                  LtlktDischarge: test.rbl_transplant_lt_lkt_discharge,
                  LtlktDischargeDate: test.transplant_lt_lkt_discharge_dt,
                  LtlktDischargeDateEstimated: test.chk_transplant_lt_lkt_discharge_est,

                  VisitType: test.rbl_lt_lkt_visit_type,
              }));




              //24 repeater - transplant visits
              const transplantVisitData = transplantVisitDetails.map((test) => ({
                  Transplantvisitid: test.transplantvisitid,

                  AdmissionVisit: test.rbl_transplant_visit_admission,
                  AdmissionVisitDate: test.transplant_visit_admission_dt,
                  AdmissionVisitDateEstimated: test.chk_transplant_visit_admission_est,

                  DischargeVisit: test.rbl_transplant_visit_discharge,
                  DischargeVisitDate: test.transplant_visit_discharge_dt,
                  DischargeVisitDateEstimated: test.chk_transplant_visit_discharge_est,

                  VisitType: test.rbl_visit_type,
              }));

              //25 repeater - rejection
              const transplantRejectionData = transplantRejectionDetails.map(
                  (test) => ({
                      Transplantrejectionid: test.transplantvisitid,

                      RejectionEpisodeStart: test.rbl_transplant_rejection_start,
                      RejectionEpisodeStartDate: test.transplant_rejection_start_dt,
                      RejectionEpisodeStartDateEstimated:
                          test.chk_transplant_rejection_start_est,

                      RejectionEpisodeEnd: test.rbl_transplant_rejection_end,
                      RejectionEpisodeEndDate: test.transplant_rejection_end_dt,
                      RejectionEpisodeEndDateEstimated:
                          test.chk_transplant_rejection_end_est,

                      RejectionType: test.rbl_rejection_type,
                  })
              );


              //26
              const transplantHospitalizationData = transplantHospitalizationDetails.map(
                  (test) => ({
                      Transplanthospitalizationid: test.transplanthospitalizationid,



                      KidneyTransplant: test.rbl_transplant_hospitalization,
                      KidneyTransplantDate: test.transplant_hospitalization_dt,
                      KidneyTransplantDateEstimated: test.chk_transplant_hospitalization_est,

                      KidneyTransplantAdmission: test.rbl_transplant_kidney_admission,
                      KidneyTransplantAdmissionDate: test.transplant_kidney_admission_dt,
                      KidneyTransplantAdmissionDateEstimated: test.chk_transplant_kidney_admission_est,

                      kidneyTransplantDischarge: test.rbl_transplant_kidney_discharge,
                      KidneyTransplantDischargeDate: test.transplant_kidney_discharge_dt,
                      KidneyTransplantDischargeDateEstimated: test.chk_transplant_kidney_discharge_est,

                      PartLkt: test.rbl_part_lkt,
                      DonorType: test.rbl_donor_type,
                      ProcedureType: test.rbl_procedure_type,
                      KidneyLocation: test.rbl_kidney_location
                  })
              );


              let liverGraftWeightValue = null;

              switch (transplantDetails.rbl_liver_graft_weight) {
                  case 1:
                      liverGraftWeightValue = transplantDetails.liver_graft_weight_value_oz;
                      break;
                  case 2:
                      liverGraftWeightValue = transplantDetails.liver_graft_weight_value_lbs;
                      break;
                  case 3:
                      liverGraftWeightValue = transplantDetails.liver_graft_weight_value_g;
                      break;
                  case 4:
                      liverGraftWeightValue = transplantDetails.liver_graft_weight_value_kg;
                      break;
              }


              if (pidRef.current > 0) {

                  const payload = {
                      PatientId: pidRef.current,
                      UserId: GetLoggedInUserID(),
                      IsValidated: validate,
                      IsAdmin: IsAdmin(),
                      TransplantVisitData: transplantVisitData,
                      TransplantRejectionData: transplantRejectionData,
                      TransplantHospitalizationsData: transplantHospitalizationData,
                      TransplantLtktData: transplantLtktData,

                      //17 admission
                      HospitalAdmissionDate: transplantAdmissionHospDate,

                      //discharge
                      HospitalDischargeDate: transplantDisDate,
                      //18
                      DonorStatus: transplantDetails.rbl_donor_status,
                      DonorHistoryDisease: transplantDetails.rbl_donor_disease_hist,
                      DonorRelationPatient: transplantDetails.rbl_donor_relation,
                      OrganReceived: transplantDetails.rbl_state_organ_rcvd,
                      AuxillaryTransplant: transplantDetails.rbl_auxillary_transplant,
                      LobeReceived: transplantDetails.rbl_lobe_rcvd,

                      //19
                      LiverGraftWeight: transplantDetails.rbl_liver_graft_weight,
                      LiverGraftWeightValue: liverGraftWeightValue,
                      // transplantDetails.rbl_liver_graft_weight === 1
                      //   ? transplantDetails.liver_graft_weight_value_oz
                      //   : transplantDetails.rbl_liver_graft_weight === 2
                      //     ? transplantDetails.liver_graft_weight_value_lbs
                      //     : transplantDetails.rbl_liver_graft_weight === 3
                      //       ? transplantDetails.liver_graft_weight_value_g
                      //       : transplantDetails.rbl_liver_graft_weight === 4
                      //         ? transplantDetails.liver_graft_weight_value_kg
                      //         : null,

                      //20
                      LtProcedureAbdominalClosure:
                          transplantDetails.chk_primary_abdominal_closure,
                      LtProcedureImmunosuppressionTherapy:
                          transplantDetails.chk_induction_immunosuppression_therapy,
                      LtProcedureNoneUnknown: transplantDetails.rbl_lt_procedure_none_Unk,

                      //21
                      RenalReplacementHemodialysis: transplantDetails.chk_hemodialysis,
                      RenalReplacementHemodiafilteration:
                          transplantDetails.chk_hemodiafiltration_hemofiltration,
                      RenalReplacementPeritonealDialysis:
                          transplantDetails.chk_peritoneal_dialysis,
                      RenalReplacementNoneUnknown:
                          transplantDetails.rbl_renal_replacement_none_unk,

                      //22

                      LiverReceipientEbv: transplantDetails.chk_liver_recipient_EBV,
                      LiverReceipientCmv: transplantDetails.chk_liver_recipient_CMV,
                      LiverReceipientNoneUnknown:
                          transplantDetails.rbl_liver_recipient_none_Unk,

                      LiverDonorEbv: transplantDetails.chk_liver_donor_EBV,
                      LiverDonorCmv: transplantDetails.chk_liver_donor_CMV,
                      LiverDonorNoneUnknown: transplantDetails.rbl_liver_donor_none_Unk,

                      //23
                      TransplantPostoperationAcutelactic:
                          transplantDetails.chk_acute_lactic_acidosis,
                      TransplantPostoperationBileLeak: transplantDetails.chk_bile_leak,
                      TransplantPostoperationThrombosis: transplantDetails.chk_thrombosis,
                      TransplantPostoperationVeinThrombosis:
                          transplantDetails.chk_portal_vein_thrombosis,
                      TransplantPostoperationArteryThrombosis:
                          transplantDetails.chk_hepatic_artery_thrombosis,
                      TransplantPostoperationThrombosisUnknown:
                          transplantDetails.rbl_type_thrombosis_unknown,
                      TransplantPostoperationBleeding:
                          transplantDetails.chk_transfusion_operative_intervention,
                      TransplantPostoperationStricture: transplantDetails.chk_stricture,
                      TransplantPostoperationBiliaryStricture:
                          transplantDetails.chk_biliary_stricture,
                      TransplantPostoperationVeinStricture:
                          transplantDetails.chk_portal_vein_stricture,
                      TransplantPostoperationArteryStricture:
                          transplantDetails.chk_hepatic_artery_stricture,
                      TransplantPostoperationHepaticVein:
                          transplantDetails.chk_hepatic_vein_stricture,
                      TransplantPostoperationStrictureUnknown:
                          transplantDetails.rbl_type_stricture_unknown,
                      TransplantPostoperationInfection: transplantDetails.chk_infection,
                      TransplantPostoperationBacteremia:
                          transplantDetails.chk_bacteremia_bloodstream_infection,
                      TransplantPostoperationAbdominal:
                          transplantDetails.chk_abdominal_wound_infection,
                      TransplantPostoperationPneumonia:
                          transplantDetails.chk_pneumonia_infection,
                      TransplantPostoperationEbv:
                          transplantDetails.chk_epstein_barr_virus_infection,
                      TransplantPostoperationCmv:
                          transplantDetails.chk_cytomegalovirus_infection,
                      TransplantPostoperationInfectionUnknown:
                          transplantDetails.rbl_type_infection_unknown,
                      TransplantPostoperationOther:
                          transplantDetails.chk_post_operative_complications_other,
                      TransplantPostoperationOtherTxt:
                          transplantDetails.txt_post_operative_complications,
                      TransplantPostoperationNone:
                          transplantDetails.rbl_post_operative_none_of_the_above,


                      ClosestOneyrIndexDate: transplantDetails.transplant_admission_dt === null || transplantDetails.transplant_admission_dt === "" ? most_ClosestoneYrpriorIndex :
                          transplantDetails.transplant_admission_dt != null || transplantDetails.transplant_admission_dt != "" && transplantAdDatechangeCount == false ? most_ClosestoneYrpriorIndex :
                              newClosestoneYrpriorIndex,

                      ClosestThreeMonthIndexDate: transplantDetails.transplant_discharge_dt === null || transplantDetails.transplant_discharge_dt === "" ? most_Closest_threemonths :
                          transplantDetails.transplant_discharge_dt != null || transplantDetails.transplant_discharge_dt != "" && transplantDisDatechangeCount == false ? most_Closest_threemonths :
                              most_newClosest_threeMonthAfterIndex,

                  };
                  ToggleLoader(true);
                  const response = await TransplantCharacteristicService.SaveData(
                      payload
                  );
                  ToggleLoader(false);
                  if (response.status !== HTTPResponse.OK) {
                      if (response?.status === HTTPResponse.Unauthorized) {
                          HandleSessionTimeout();
                      } else throw response.error;
                  } else {
                      ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                      if (response) {
                          const { data } = response;

                          if (data) {
                              SetFields(data);
                          }
                          await LoadData();
                      }
                      if (response?.data?.showTransplantDateChangeAlert) {
                          ShowAlertBox();
                      }
                  }
              }
          }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const Validate = () => {
    let isValid = true;

    //18

    let rbl_donor_statusEmpty = false;
    let rbl_donor_disease_histEmpty = false;
    let rbl_donor_relationEmpty = false;
    let rbl_state_organ_rcvdEmpty = false;
    //E and F
    let rbl_auxillary_transplantEmpty = false;
    let rbl_lobe_rcvdEmpty = false;

    if (transplantDetails.rbl_donor_status === null) {
      rbl_donor_statusEmpty = true;
    }

    if (transplantDetails.rbl_donor_disease_hist === null) {
      rbl_donor_disease_histEmpty = true;
    }

    if (transplantDetails.rbl_donor_relation === null) {
      rbl_donor_relationEmpty = true;
    }

    if (transplantDetails.rbl_state_organ_rcvd === null) {
      rbl_state_organ_rcvdEmpty = true;
    }

    //E and F
    if (
      transplantDetails.rbl_state_organ_rcvd !== 1 &&
      transplantDetails.rbl_auxillary_transplant === null
    ) {
      rbl_auxillary_transplantEmpty = true;
    }

    if (
      transplantDetails.rbl_state_organ_rcvd !== 1 &&
      transplantDetails.rbl_lobe_rcvd === null
    ) {
      rbl_lobe_rcvdEmpty = true;
    }

    //19
    let rbl_liver_graft_weightEmpty = false;
    let rbl_liver_graft_weight_valueEmpty = false;
    let rbl_liver_graft_weight_invalid = false;

    if (transplantDetails.rbl_liver_graft_weight === null) {
      rbl_liver_graft_weightEmpty = true;
    }
    if (
      transplantDetails.rbl_liver_graft_weight !== 99 &&
      transplantDetails.rbl_liver_graft_weight !== null &&
      transplantDetails.liver_graft_weight_value_oz === "" &&
      transplantDetails.liver_graft_weight_value_lbs === "" &&
      transplantDetails.liver_graft_weight_value_g === "" &&
      transplantDetails.liver_graft_weight_value_kg === ""
    ) {
      rbl_liver_graft_weight_valueEmpty = true;
    }

    const MAX_WEIGHT_G = 1500;

    const MAX_WEIGHT_LBS = MAX_WEIGHT_G / 453.592; // ~3.31 lbs
    const MAX_WEIGHT_OZ = MAX_WEIGHT_G / 28.35; // ~52.91 oz
    const MAX_WEIGHT_KG = MAX_WEIGHT_G / 1000; // 1.5 kg

    if (transplantDetails.rbl_liver_graft_weight !== null &&
      transplantDetails.liver_graft_weight_value_oz &&
      (transplantDetails.liver_graft_weight_value_oz < 0 || transplantDetails.liver_graft_weight_value_oz > MAX_WEIGHT_OZ)
    ) {
      rbl_liver_graft_weight_invalid = true;
    }

    if (transplantDetails.rbl_liver_graft_weight !== null &&
      transplantDetails.liver_graft_weight_value_lbs &&
      (transplantDetails.liver_graft_weight_value_lbs < 0 || transplantDetails.liver_graft_weight_value_lbs > MAX_WEIGHT_LBS)
    ) {
      rbl_liver_graft_weight_invalid = true;
    }

    if (transplantDetails.rbl_liver_graft_weight !== null &&
      transplantDetails.liver_graft_weight_value_g &&
      (transplantDetails.liver_graft_weight_value_g < 0 || transplantDetails.liver_graft_weight_value_g > 1500)
    ) {
      rbl_liver_graft_weight_invalid = true;
    }

    if (transplantDetails.rbl_liver_graft_weight !== null &&
      transplantDetails.liver_graft_weight_value_kg &&
      (transplantDetails.liver_graft_weight_value_kg < 0 || transplantDetails.liver_graft_weight_value_kg > MAX_WEIGHT_KG)
    ) {
      rbl_liver_graft_weight_invalid = true;
    }

    //20
    let indicate_LT_ProcedureEmpty = false;
    if (
      !transplantDetails.chk_primary_abdominal_closure &&
      !transplantDetails.chk_induction_immunosuppression_therapy &&
      transplantDetails.rbl_lt_procedure_none_Unk === null
    ) {
      indicate_LT_ProcedureEmpty = true;
    }

    //21
    let renal_replacementEmpty = false;
    if (
      !transplantDetails.chk_hemodialysis &&
      !transplantDetails.chk_hemodiafiltration_hemofiltration &&
      !transplantDetails.chk_peritoneal_dialysis &&
      transplantDetails.rbl_renal_replacement_none_unk === null
    ) {
      renal_replacementEmpty = true;
    }

    //22
    let liver_recipientEmpty = false;

    if (
      !transplantDetails.chk_liver_recipient_EBV &&
      !transplantDetails.chk_liver_recipient_CMV &&
      transplantDetails.rbl_liver_recipient_none_Unk === null
    ) {
      liver_recipientEmpty = true;
    }

    //donor
    let liver_donorEmpty = false;
    if (
      !transplantDetails.chk_liver_donor_EBV &&
      !transplantDetails.chk_liver_donor_CMV &&
      transplantDetails.rbl_liver_donor_none_Unk === null
    ) {
      liver_donorEmpty = true;
    }

    //23
    let transplant_post_operative_complicationsEmpty = false;
    if (
      !transplantDetails.chk_acute_lactic_acidosis &&
      !transplantDetails.chk_bile_leak &&
      !transplantDetails.chk_thrombosis &&
      !transplantDetails.chk_transfusion_operative_intervention &&
      !transplantDetails.chk_stricture &&
      !transplantDetails.chk_infection &&
      !transplantDetails.chk_post_operative_complications_other &&
      transplantDetails.rbl_post_operative_none_of_the_above === null) {
      transplant_post_operative_complicationsEmpty = true;
    }


    if (transplantDetails.chk_thrombosis &&
      !transplantDetails.chk_portal_vein_thrombosis &&
      !transplantDetails.chk_hepatic_artery_thrombosis &&
      transplantDetails.rbl_type_thrombosis_unknown === null
    ) {
      transplant_post_operative_complicationsEmpty = true;
    }



    if (transplantDetails.chk_stricture &&
      !transplantDetails.chk_biliary_stricture &&
      !transplantDetails.chk_portal_vein_stricture &&
      !transplantDetails.chk_hepatic_artery_stricture &&
      !transplantDetails.chk_hepatic_vein_stricture &&
      transplantDetails.rbl_type_stricture_unknown === null
    ) {
      transplant_post_operative_complicationsEmpty = true;
    }



    if (transplantDetails.chk_infection &&
      !transplantDetails.chk_bacteremia_bloodstream_infection &&
      !transplantDetails.chk_abdominal_wound_infection &&
      !transplantDetails.chk_pneumonia_infection &&
      !transplantDetails.chk_epstein_barr_virus_infection &&
      !transplantDetails.chk_cytomegalovirus_infection &&
      transplantDetails.rbl_type_infection_unknown === null) {
      transplant_post_operative_complicationsEmpty = true;
    }




    if (transplantDetails.chk_post_operative_complications_other &&
      transplantDetails.txt_post_operative_complications === "") {
      transplant_post_operative_complicationsEmpty = true;
    }

    

//17
    let earliest_lt_lkt_dt_Invalid = false
    // earliest transplant admission date - less than index date 
    if (   
      !IsDateEmpty(transplantAdmissionHospDate) &&
      !IsDateEmpty(dates.indexDt) &&
      !DateValid(transplantAdmissionHospDate, dates.indexDt)
    ) {
      earliest_lt_lkt_dt_Invalid = true;
    }

    let latest_lt_lkt_Invalid = false;
    //Latest trasnplant date - less than endofFollowUp
    if (
      !IsDateEmpty(transplantDisDate) &&
      !IsDateEmpty(dates.indexDt) &&
      !DateValid(transplantDisDate, dates.endofFollowUpDate)
    ) {
      latest_lt_lkt_Invalid = true;
    }




//17
if (transplantRelatedHospitalization && transplantRelatedHospitalization.length > 0) {
  const updatedArray = transplantRelatedHospitalization.map((item) => {
    let transplant_lt_lkt_admissionEmpty = false;
    if (item.rbl_transplant_lt_lkt_admission === null) {
      transplant_lt_lkt_admissionEmpty = true;
    }

    let transplant_admission_lt_lkt_dt_empty = false;
    if (
      item.rbl_transplant_lt_lkt_admission === Values.value1 &&
      item.transplant_lt_lkt_admission_dt === null
    ) {
      transplant_admission_lt_lkt_dt_empty = true;
    }

    let transplant_admission_lt_lkt_dt_invalid = false;

    // date less than discharge
    if (
      item.rbl_transplant_lt_lkt_admission === Values.value1 &&
      !IsDateEmpty(item.transplant_lt_lkt_admission_dt) &&
      !IsDateEmpty(item.transplant_lt_lkt_discharge_dt) &&
      !DateValid(item.transplant_lt_lkt_admission_dt, item.transplant_lt_lkt_discharge_dt)
    ) {
      transplant_admission_lt_lkt_dt_invalid = true;
    }


    // let earliest_lt_lkt_dt_Invalid = false
    // // earliest transplant admission date - less than index date 
    // if (
    //   item.rbl_transplant_lt_lkt_admission === Values.value1 &&
    //   !IsDateEmpty(transplantAdmissionHospDate) &&
    //   !IsDateEmpty(dates.indexDt) &&
    //   !DateValid(transplantAdmissionHospDate, dates.indexDt)
    // ) {
    //   earliest_lt_lkt_dt_Invalid = true;
    // }

    // let latest_lt_lkt_Invalid = false;
    // //Latest trasnplant date - less than endofFollowUp
    // if (
    //   item.rbl_transplant_lt_lkt_admission === Values.value1 &&
    //   !IsDateEmpty(transplantDisDate) &&
    //   !IsDateEmpty(dates.indexDt) &&
    //   !DateValid(transplantDisDate, dates.endofFollowUpDate)
    // ) {
    //   latest_lt_lkt_Invalid = true;
    // }




    //discharge
    let transplant_lt_lkt_dischargeEmpty = false;
    if (
      item.rbl_transplant_lt_lkt_discharge === null
    ) {
      transplant_lt_lkt_dischargeEmpty = true;
    }

    
    let transplant_discharge_lt_lkt_dt_empty = false;
    if (
      item.rbl_transplant_lt_lkt_discharge === Values.value1 &&
      item.transplant_lt_lkt_discharge_dt === null
    ) {
      transplant_discharge_lt_lkt_dt_empty = true;
    }

    let transplant_discharge_lt_lkt_dt_invalid = false;

    // discharge date should be greater than admission 
    if (
      item.rbl_transplant_lt_lkt_discharge === Values.value1 &&
      !IsDateEmpty(item.transplant_lt_lkt_admission_dt) &&
      !IsDateEmpty(item.transplant_lt_lkt_discharge_dt) &&
      !DateValid(item.transplant_lt_lkt_admission_dt, item.transplant_lt_lkt_discharge_dt)
    ) {
      transplant_discharge_lt_lkt_dt_invalid = true;
    }


    // if (
    //   item.rbl_transplant_lt_lkt_discharge === Values.value1 &&
    //   !IsDateEmpty(item.transplant_lt_lkt_discharge_dt) &&
    //   !IsDateEmpty(dates.indexDt) && 
    //   !DateValid(dates.indexDt, item.transplant_lt_lkt_discharge_dt)
    // ) {
    //   transplant_discharge_lt_lkt_dt_invalid = true;
    // }

    // endOfFollowUp should be greater than discharge
    // if (
    //   item.rbl_transplant_lt_lkt_discharge === Values.value1 &&
    //   !IsDateEmpty(item.transplant_lt_lkt_discharge_dt) &&
    //   !IsDateEmpty(dates.endofFollowUpDate) && 
    //   !DateValid(item.transplant_lt_lkt_discharge_dt, dates.endofFollowUpDate)
    // ) {
    //   transplant_discharge_lt_lkt_dt_invalid = true;
    // }



    let lt_lkt_visit_typeEmpty = false;
    if (
      item.rbl_lt_lkt_visit_type === null
    ) {
      lt_lkt_visit_typeEmpty = true;
    }

    if (
      transplant_lt_lkt_admissionEmpty ||
      transplant_admission_lt_lkt_dt_empty ||
      transplant_admission_lt_lkt_dt_invalid ||
      transplant_lt_lkt_dischargeEmpty ||
      transplant_discharge_lt_lkt_dt_empty ||
      transplant_discharge_lt_lkt_dt_invalid ||
      lt_lkt_visit_typeEmpty 
    ) {
      isValid = false;
    }
    return {
      ...item,
      transplant_lt_lkt_admissionEmpty,
      transplant_admission_lt_lkt_dt_empty,
      transplant_admission_lt_lkt_dt_invalid,
      transplant_lt_lkt_dischargeEmpty,
      transplant_discharge_lt_lkt_dt_empty,
      transplant_discharge_lt_lkt_dt_invalid,
      lt_lkt_visit_typeEmpty,
    };
  });
  setTransplantRelatedHospitalization(updatedArray);
}




    //24


    if (transplantVisitDetails && transplantVisitDetails.length > 0) {
      const updatedArray = transplantVisitDetails.map((item) => {
        let transplant_visit_admissionEmpty = false;
        if (item.rbl_transplant_visit_admission === null) {
          transplant_visit_admissionEmpty = true;
        }

        let transplant_admission_visit_dt_empty = false;
        if (
          item.rbl_transplant_visit_admission === 2 &&
          item.transplant_visit_admission_dt === null
        ) {
          transplant_admission_visit_dt_empty = true;
        }

        let transplant_admission_visit_dt_invalid = false;
        if (
          item.rbl_transplant_visit_admission === 2 &&
          !IsDateEmpty(item.transplant_visit_admission_dt) &&
          !IsDateEmpty(item.transplant_visit_discharge_dt) &&
          !DateValid(item.transplant_visit_admission_dt, item.transplant_visit_discharge_dt)
        ) {
          transplant_admission_visit_dt_invalid = true;
        }

        if (
          item.rbl_transplant_visit_admission === 2 &&
          !IsDateEmpty(item.transplant_visit_admission_dt) &&
          !IsDateEmpty(transplantDetails.transplant_admission_dt) &&
          !DateValid(transplantDetails.transplant_admission_dt, item.transplant_visit_admission_dt)
        ) {
          transplant_admission_visit_dt_invalid = true;
        }

        // if (
        //   item.rbl_transplant_visit_admission === 2 &&
        //   !IsDateEmpty(transplantDetails.transplant_admission_dt)&&
        //   !IsDateEmpty(item.transplant_visit_admission_dt) &&
        //   !IsDateEmpty(item.transplant_visit_discharge_dt) &&

        //   !IsValidRange(
        //     transplantDetails.transplant_admission_dt,
        //     item.transplant_visit_admission_dt,
        //     item.transplant_visit_discharge_dt
        //   )
        // ) {
        //   transplant_admission_visit_dt_invalid = true;
        // }

        //discharge
        let transplant_visit_dischargeEmpty = false;
        if (
          item.rbl_transplant_visit_admission !== 1 &&
          item.rbl_transplant_visit_discharge === null
        ) {
          transplant_visit_dischargeEmpty = true;
        }

        let transplant_discharge_visit_dt_empty = false;
        if (
          item.rbl_transplant_visit_admission !== 1 &&
          item.rbl_transplant_visit_discharge === 2 &&
          item.transplant_visit_discharge_dt === null
        ) {
          transplant_discharge_visit_dt_empty = true;
        }

        let transplant_discharge_visit_dt_invalid = false;


        if (
          item.rbl_transplant_visit_admission !== 1 &&
          item.rbl_transplant_visit_discharge === 2 &&
          !IsDateEmpty(item.transplant_visit_admission_dt) &&
          !IsDateEmpty(item.transplant_visit_discharge_dt) &&
          !DateValid(item.transplant_visit_admission_dt, item.transplant_visit_discharge_dt)
        ) {
          transplant_discharge_visit_dt_invalid = true;
        }

        if (
          item.rbl_transplant_visit_admission !== 1 &&
          item.rbl_transplant_visit_discharge === 2 &&
          !IsDateEmpty(item.transplant_visit_admission_dt) &&
          !IsDateEmpty(transplantDetails.transplant_admission_dt) &&
          !DateValid(transplantDetails.transplant_admission_dt, item.transplant_visit_discharge_dt)
        ) {
          transplant_discharge_visit_dt_invalid = true;
        }

        // if (
        //   item.rbl_transplant_visit_admission !== 1 &&
        //   item.rbl_transplant_visit_discharge === 2 &&
        //   !IsDateEmpty(item.transplant_visit_admission_dt) &&
        //     !IsDateEmpty(item.transplant_visit_discharge_dt) &&
        //     !IsDateEmpty(transplantDetails.transplant_admission_dt) &&

        //     !IsValidRange(
        //       transplantDetails.transplant_admission_dt,
        //       item.transplant_visit_admission_dt,
        //       item.transplant_visit_discharge_dt
        //   )
        // ) {
        //   transplant_discharge_visit_dt_invalid = true;
        // }

        let visit_typeEmpty = false;
        if (
          item.rbl_transplant_visit_admission !== 1 &&
          item.rbl_visit_type === null
        ) {
          visit_typeEmpty = true;
        }

        if (
          transplant_visit_admissionEmpty ||
          transplant_admission_visit_dt_empty ||
          transplant_admission_visit_dt_invalid ||
          transplant_visit_dischargeEmpty ||
          transplant_discharge_visit_dt_empty ||
          transplant_discharge_visit_dt_invalid ||
          visit_typeEmpty
        ) {
          isValid = false;
        }
        return {
          ...item,
          transplant_visit_admissionEmpty,
          transplant_admission_visit_dt_empty,
          transplant_admission_visit_dt_invalid,
          transplant_visit_dischargeEmpty,
          transplant_discharge_visit_dt_empty,
          transplant_discharge_visit_dt_invalid,
          visit_typeEmpty,
        };
      });
      setTransplantVisitDetails(updatedArray);
    }

    //25 - rejection
    if (transplantRejectionDetails && transplantRejectionDetails.length > 0) {
      const updatedArray = transplantRejectionDetails.map((item) => {
        let transplant_rejection_startEmpty = false;
        if (item.rbl_transplant_rejection_start === null) {
          transplant_rejection_startEmpty = true;
        }

        let transplant_rejection_start_dt_empty = false;
        if (
          item.rbl_transplant_rejection_start === 2 &&
          item.transplant_rejection_start_dt === null
        ) {
          transplant_rejection_start_dt_empty = true;
        }

        let transplant_rejection_start_dt_invalid = false;
        if (item.rbl_transplant_rejection_start === 2 &&
          !IsDateEmpty(dates.indexDt) &&
          !IsDateEmpty(item.transplant_rejection_start_dt) &&
          !DateValid(dates.indexDt, item.transplant_rejection_start_dt)
        ) {
          transplant_rejection_start_dt_invalid = true
        }


        if (item.rbl_transplant_rejection_start === 2 &&
          !IsDateEmpty(item.transplant_rejection_start_dt) &&
          !IsDateEmpty(item.transplant_rejection_end_dt) &&
          !DateValid(item.transplant_rejection_start_dt, item.transplant_rejection_end_dt)
        ) {
          transplant_rejection_start_dt_invalid = true
        }


        if (item.rbl_transplant_rejection_start === 2 &&
          !IsDateEmpty(item.transplant_rejection_start_dt) &&
          !IsDateEmpty(dates.endofFollowUpDate) &&
          !DateValid(item.transplant_rejection_start_dt, dates.endofFollowUpDate)
        ) {
          transplant_rejection_start_dt_invalid = true
        }


        //discharge
        let transplant_rejection_endEmpty = false;
        if (
          item.rbl_transplant_rejection_start !== 1 &&
          item.rbl_transplant_rejection_end === null
        ) {
          transplant_rejection_endEmpty = true;
        }

        let transplant_rejection_end_dt_empty = false;
        if (
          item.rbl_transplant_rejection_start !== 1 &&
          item.rbl_transplant_rejection_end === 2 &&
          item.transplant_rejection_end_dt === null
        ) {
          transplant_rejection_end_dt_empty = true;
        }

        let transplant_rejection_end_dt_invalid = false;
        //end date should be greater than index 
        if (
          item.rbl_transplant_rejection_start !== 1 &&
          item.rbl_transplant_rejection_end === 2 &&

          !IsDateEmpty(dates.indexDt) &&
          !IsDateEmpty(item.transplant_rejection_end_dt) &&
          !DateValid(dates.indexDt, item.transplant_rejection_end_dt)
        ) {
          transplant_rejection_end_dt_invalid = true
        }
        //end date should be greater than start
        if (
          item.rbl_transplant_rejection_start !== 1 &&
          item.rbl_transplant_rejection_end === 2 &&

          !IsDateEmpty(item.transplant_rejection_start_dt) &&
          !IsDateEmpty(item.transplant_rejection_end_dt) &&
          !DateValid(item.transplant_rejection_start_dt, item.transplant_rejection_end_dt)
        ) {
          transplant_rejection_end_dt_invalid = true
        }


        if (
          item.rbl_transplant_rejection_start !== 1 &&
          item.rbl_transplant_rejection_end === 2 &&

          !IsDateEmpty(item.transplant_rejection_end_dt) &&
          !IsDateEmpty(dates.endofFollowUpDate) &&
          !DateValid(item.transplant_rejection_end_dt, dates.endofFollowUpDate)
        ) {
          transplant_rejection_end_dt_invalid = true
        }


        let rejection_typeEmpty = false;
        if (
          item.rbl_transplant_rejection_start !== 1 &&
          item.rbl_rejection_type === null
        ) {
          rejection_typeEmpty = true;
        }

        if (
          transplant_rejection_startEmpty ||
          transplant_rejection_start_dt_empty ||
          transplant_rejection_start_dt_invalid ||
          transplant_rejection_endEmpty ||
          transplant_rejection_end_dt_empty ||
          transplant_rejection_end_dt_invalid ||
          rejection_typeEmpty
        ) {
          isValid = false;
        }
        return {
          ...item,
          transplant_rejection_startEmpty,
          transplant_rejection_start_dt_empty,
          transplant_rejection_start_dt_invalid,
          transplant_rejection_endEmpty,
          transplant_rejection_end_dt_empty,
          transplant_rejection_end_dt_invalid,
          rejection_typeEmpty,
        };
      });
      setTransplantRejectionDetails(updatedArray);
    }

    if (transplantHospitalizationDetails && transplantHospitalizationDetails.length > 0) {
      const updatedArray = transplantHospitalizationDetails.map((item) => {


        let rbl_transplant_hospitalizationEmpty = false;
        if (item.rbl_transplant_hospitalization === null) {
          rbl_transplant_hospitalizationEmpty = true;
        }


        let transplant_hospitalization_dt_empty = false;
        if (
          item.rbl_transplant_hospitalization === 2 &&
          item.transplant_hospitalization_dt === null
        ) {
          transplant_hospitalization_dt_empty = true;
        }


        let transplant_hospitalization_dt_invalid = false;

        if (item.rbl_transplant_hospitalization === 2 &&
          !IsDateEmpty(item.transplant_kidney_admission_dt) &&
          !IsDateEmpty(item.transplant_hospitalization_dt) &&
          !DateValid(item.transplant_kidney_admission_dt, item.transplant_hospitalization_dt)
        ) {
          transplant_hospitalization_dt_invalid = true
        }

        if (item.rbl_transplant_hospitalization === 2 &&
          !IsDateEmpty(item.transplant_kidney_discharge_dt) &&
          !IsDateEmpty(item.transplant_hospitalization_dt) &&

          !DateValid(item.transplant_hospitalization_dt, item.transplant_kidney_discharge_dt)
        ) {
          transplant_hospitalization_dt_invalid = true
        }



        //col2 

        let transplant_kidney_admissionEmpty = false;
        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_transplant_kidney_admission === null) {
          transplant_kidney_admissionEmpty = true;
        }


        let transplant_kidney_admission_dt_empty = false;
        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_transplant_kidney_admission === 1 &&
          item.transplant_kidney_admission_dt === null
        ) {
          transplant_kidney_admission_dt_empty = true;
        }



        let transplant_kidney_admission_dt_invalid = false;

        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_transplant_kidney_admission === 1 &&
          !IsDateEmpty(item.transplant_kidney_admission_dt) &&
          !IsDateEmpty(item.transplant_hospitalization_dt) &&
          !DateValid(item.transplant_kidney_admission_dt, item.transplant_hospitalization_dt)
        ) {
          transplant_kidney_admission_dt_invalid = true
        }


        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_transplant_kidney_admission === 1 &&
          !IsDateEmpty(item.transplant_kidney_admission_dt) &&
          !IsDateEmpty(item.transplant_kidney_discharge_dt) &&
          !DateValid(item.transplant_kidney_admission_dt, item.transplant_kidney_discharge_dt)
        ) {
          transplant_kidney_admission_dt_invalid = true
        }


        //col 3


        let transplant_kidney_dischargeEmpty = false;
        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_transplant_kidney_discharge === null) {
          transplant_kidney_dischargeEmpty = true;
        }


        let transplant_kidney_discharge_dt_empty = false;
        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_transplant_kidney_discharge === 1 &&
          item.transplant_kidney_discharge_dt === null
        ) {
          transplant_kidney_discharge_dt_empty = true;
        }




        let transplant_kidney_discharge_dt_invalid = false;

        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_transplant_kidney_discharge === 1 &&
          !IsDateEmpty(item.transplant_kidney_discharge_dt) &&
          !IsDateEmpty(item.transplant_kidney_admission_dt) &&
          !DateValid(item.transplant_kidney_admission_dt, item.transplant_kidney_discharge_dt)
        ) {
          transplant_kidney_discharge_dt_invalid = true
        }



        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_transplant_kidney_discharge === 1 &&
          !IsDateEmpty(item.transplant_kidney_discharge_dt) &&
          !IsDateEmpty(item.transplant_hospitalization_dt) &&
          !DateValid(item.transplant_hospitalization_dt, item.transplant_kidney_discharge_dt)
        ) {
          transplant_kidney_discharge_dt_invalid = true
        }

        //col 4 part of lkt
        let part_lktEmpty = false;
        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_part_lkt === null
        ) {
          part_lktEmpty = true;
        }

        //col5 
        let transplant_donor_typeEmpty = false;
        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_donor_type === null
        ) {
          transplant_donor_typeEmpty = true;
        }

        //col6
        let transplant_procedure_typeEmpty = false;
        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_procedure_type === null
        ) {
          transplant_procedure_typeEmpty = true;
        }


        //col7
        let transplant_kidney_locationEmpty = false;
        if (
          item.rbl_transplant_hospitalization !== 1 &&
          item.rbl_procedure_type === 1 &&
          item.rbl_kidney_location === null
        ) {
          transplant_kidney_locationEmpty = true;
        }

        if (
          rbl_transplant_hospitalizationEmpty ||
          transplant_hospitalization_dt_empty ||
          transplant_hospitalization_dt_invalid ||
          transplant_kidney_admissionEmpty ||
          transplant_kidney_admission_dt_empty ||
          transplant_kidney_admission_dt_invalid ||

          transplant_kidney_dischargeEmpty ||
          transplant_kidney_discharge_dt_empty ||
          transplant_kidney_discharge_dt_invalid ||

          part_lktEmpty ||
          transplant_donor_typeEmpty ||
          transplant_procedure_typeEmpty ||
          transplant_kidney_locationEmpty
        ) {
          isValid = false;
        }
        return {
          ...item,
          rbl_transplant_hospitalizationEmpty,
          transplant_hospitalization_dt_empty,
          transplant_hospitalization_dt_invalid,
          transplant_kidney_admissionEmpty,
          transplant_kidney_admission_dt_empty,
          transplant_kidney_admission_dt_invalid,

          transplant_kidney_dischargeEmpty,
          transplant_kidney_discharge_dt_empty,
          transplant_kidney_discharge_dt_invalid,

          part_lktEmpty,
          transplant_donor_typeEmpty,
          transplant_procedure_typeEmpty,
          transplant_kidney_locationEmpty
        };
      });
      setTransplantHospitalizationDetails(updatedArray);
    }

    setHardErrList((prev) => ({
      ...prev,
      rbl_donor_statusEmpty,
      rbl_donor_disease_histEmpty,
      rbl_donor_relationEmpty,
      rbl_state_organ_rcvdEmpty,
      rbl_auxillary_transplantEmpty,
      rbl_lobe_rcvdEmpty,
      rbl_liver_graft_weightEmpty,
      rbl_liver_graft_weight_valueEmpty,
      rbl_liver_graft_weight_invalid,
      indicate_LT_ProcedureEmpty,
      renal_replacementEmpty,
      liver_recipientEmpty,
      liver_donorEmpty,
      transplant_post_operative_complicationsEmpty,
      earliest_lt_lkt_dt_Invalid,
      latest_lt_lkt_Invalid
    }));

    if (
      rbl_donor_statusEmpty ||
      rbl_donor_disease_histEmpty ||
      rbl_donor_relationEmpty ||
      rbl_state_organ_rcvdEmpty ||
      rbl_auxillary_transplantEmpty ||
      rbl_lobe_rcvdEmpty ||
      rbl_liver_graft_weightEmpty ||
      rbl_liver_graft_weight_valueEmpty ||
      rbl_liver_graft_weight_invalid ||
      indicate_LT_ProcedureEmpty ||
      renal_replacementEmpty ||
      liver_recipientEmpty ||
      liver_donorEmpty ||
      transplant_post_operative_complicationsEmpty ||
      latest_lt_lkt_Invalid ||
      earliest_lt_lkt_dt_Invalid
    ) {
      isValid = false;
    }
    return isValid;
  };

  useEffect(() => {
    async function FetchData() {
      pidRef.current = GetLocalStorageData("patientId") || 0;
      if (pidRef.current !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const HandleFieldChange = (e) => {

    const { name, value } = e.target;
    switch (name) {

      //18 donor status
      case "rbl_donor_status":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
          }));

          setHardErrList((prev) => ({
            ...prev,
            rbl_donor_statusEmpty: false,
          }));
        }
        break;

      //donor disease history
      case "rbl_donor_disease_hist":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
          }));

          setHardErrList((prev) => ({
            ...prev,
            rbl_donor_disease_histEmpty: false,
          }));
        }
        break;

      //donor relation
      case "rbl_donor_relation":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
          }));

          setHardErrList((prev) => ({
            ...prev,
            rbl_donor_relationEmpty: false,
          }));
        }
        break;

      //State of organ received
      case "rbl_state_organ_rcvd":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            rbl_auxillary_transplant:
              Number(value) === Values.value1
                ? null
                : prev.rbl_auxillary_transplant,
            rbl_lobe_rcvd:
              Number(value) === Values.value1 ? null : prev.rbl_lobe_rcvd,
          }));

          if (Number(value) === Values.value1) {
            setHardErrList((prev) => ({
              ...prev,
              rbl_auxillary_transplantEmpty: false,
              rbl_lobe_rcvdEmpty: false,
            }));
          }

          setHardErrList((prev) => ({
            ...prev,
            rbl_state_organ_rcvdEmpty: false,
          }));
        }
        break;

      //	Auxiliary transplant
      case "rbl_auxillary_transplant":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
          }));

          setHardErrList((prev) => ({
            ...prev,
            rbl_auxillary_transplantEmpty: false,
          }));
        }
        break;

      //	Lobe received
      case "rbl_lobe_rcvd":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
          }));

          setHardErrList((prev) => ({
            ...prev,
            rbl_lobe_rcvdEmpty: false,
          }));
        }
        break;

      //19
      case "rbl_liver_graft_weight":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            liver_graft_weight_value_oz: "",
            liver_graft_weight_value_lbs: "",
            liver_graft_weight_value_g: "",
            liver_graft_weight_value_kg: "",
          }));

          setHardErrList((prev) => ({
            ...prev,
            rbl_liver_graft_weightEmpty: false,
            rbl_liver_graft_weight_valueEmpty: false,
            rbl_liver_graft_weight_invalid: false,
          }));
        }
        break;

      case "liver_graft_weight_value_oz":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: AllowNumberWithTwoDecimal(value) ? value : prev[name],
            rbl_liver_graft_weight: 1,
            liver_graft_weight_value_lbs: "",
            liver_graft_weight_value_g: "",
            liver_graft_weight_value_kg: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            rbl_liver_graft_weightEmpty: false,
            rbl_liver_graft_weight_valueEmpty: false,
            rbl_liver_graft_weight_invalid: false
          }));
        }
        break;

      case "liver_graft_weight_value_lbs":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: AllowNumberWithTwoDecimal(value) ? value : prev[name],
            rbl_liver_graft_weight: 2,
            liver_graft_weight_value_oz: "",
            liver_graft_weight_value_g: "",
            liver_graft_weight_value_kg: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            rbl_liver_graft_weightEmpty: false,
            rbl_liver_graft_weight_valueEmpty: false,
            rbl_liver_graft_weight_invalid: false
          }));
        }
        break;

      case "liver_graft_weight_value_g":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: AllowNumberWithTwoDecimal(value) ? value : prev[name],
            rbl_liver_graft_weight: 3,
            liver_graft_weight_value_oz: "",
            liver_graft_weight_value_lbs: "",
            liver_graft_weight_value_kg: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            rbl_liver_graft_weightEmpty: false,
            rbl_liver_graft_weight_valueEmpty: false,
            rbl_liver_graft_weight_invalid: false
          }));
        }
        break;

      case "liver_graft_weight_value_kg":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: AllowNumberWithTwoDecimal(value) ? value : prev[name],
            rbl_liver_graft_weight: 4,
            liver_graft_weight_value_oz: "",
            liver_graft_weight_value_lbs: "",
            liver_graft_weight_value_g: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            rbl_liver_graft_weightEmpty: false,
            rbl_liver_graft_weight_valueEmpty: false,
            rbl_liver_graft_weight_invalid: false
          }));
        }
        break;

      //20
      case "chk_primary_abdominal_closure":
      case "chk_induction_immunosuppression_therapy":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_lt_procedure_none_Unk: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            indicate_LT_ProcedureEmpty: false,
          }));
        }
        break;

      // case "chk_induction_immunosuppression_therapy":
      //   {
      //     setTransplantDetails((prev) => ({
      //       ...prev,
      //       [name]: !prev[name],
      //       rbl_lt_procedure_none_Unk: null,
      //     }));

      //     setHardErrList((prev) => ({
      //       ...prev,
      //       indicate_LT_ProcedureEmpty: false,
      //     }));
      //   }
      //   break;

      case "rbl_lt_procedure_none_Unk":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_induction_immunosuppression_therapy: "",
            chk_primary_abdominal_closure: "",
          }));

          setHardErrList((prev) => ({
            ...prev,
            indicate_LT_ProcedureEmpty: false,
          }));
        }
        break;

      //21
      case "chk_hemodialysis":
      case "chk_hemodiafiltration_hemofiltration":
      case "chk_peritoneal_dialysis":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_renal_replacement_none_unk: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            renal_replacementEmpty: false,
          }));
        }
        break;

      // case "chk_hemodiafiltration_hemofiltration":
      //   {
      //     setTransplantDetails((prev) => ({
      //       ...prev,
      //       [name]: !prev[name],
      //       rbl_renal_replacement_none_unk: null,
      //     }));

      //     setHardErrList((prev) => ({
      //       ...prev,
      //       renal_replacementEmpty: false,
      //     }));
      //   }
      //   break;

      // case "chk_peritoneal_dialysis":
      //   {
      //     setTransplantDetails((prev) => ({
      //       ...prev,
      //       [name]: !prev[name],
      //       rbl_renal_replacement_none_unk: null,
      //     }));

      //     setHardErrList((prev) => ({
      //       ...prev,
      //       renal_replacementEmpty: false,
      //     }));
      //   }
      //   break;

      case "rbl_renal_replacement_none_unk":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_hemodialysis: "",
            chk_hemodiafiltration_hemofiltration: "",
            chk_peritoneal_dialysis: "",
          }));

          setHardErrList((prev) => ({
            ...prev,
            renal_replacementEmpty: false,
          }));
        }
        break;

      //22recipient
      case "chk_liver_recipient_EBV":
      case "chk_liver_recipient_CMV":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_liver_recipient_none_Unk: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            liver_recipientEmpty: false,
          }));
        }
        break;

      // case "chk_liver_recipient_CMV":
      //   {
      //     setTransplantDetails((prev) => ({
      //       ...prev,
      //       [name]: !prev[name],
      //       rbl_liver_recipient_none_Unk: null,
      //     }));

      //     setHardErrList((prev) => ({
      //       ...prev,
      //       liver_recipientEmpty: false,
      //     }));
      //   }
      //   break;

      case "rbl_liver_recipient_none_Unk":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_liver_recipient_EBV: "",
            chk_liver_recipient_CMV: "",
          }));

          setHardErrList((prev) => ({
            ...prev,
            liver_recipientEmpty: false,
          }));
        }
        break;

      //donor
      case "chk_liver_donor_EBV":
      case "chk_liver_donor_CMV":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_liver_donor_none_Unk: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            liver_donorEmpty: false,
          }));
        }
        break;

      // case "chk_liver_donor_CMV":
      //   {
      //     setTransplantDetails((prev) => ({
      //       ...prev,
      //       [name]: !prev[name],
      //       rbl_liver_donor_none_Unk: null,
      //     }));

      //     setHardErrList((prev) => ({
      //       ...prev,
      //       liver_donorEmpty: false,
      //     }));
      //   }
      //   break;

      case "rbl_liver_donor_none_Unk":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_liver_donor_EBV: "",
            chk_liver_donor_CMV: "",
          }));

          setHardErrList((prev) => ({
            ...prev,
            liver_donorEmpty: false,
          }));
        }
        break;

      //23
      // Acute lactic acidosis
      case "chk_acute_lactic_acidosis":
      case "chk_bile_leak":
      case "chk_transfusion_operative_intervention":

        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_post_operative_none_of_the_above: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;


      //Bile leak
      // case "chk_bile_leak":
      //   {
      //     setTransplantDetails((prev) => ({
      //       ...prev,
      //       [name]: !prev[name],
      //       rbl_post_operative_none_of_the_above: null,
      //     }));

      //     setHardErrList((prev) => ({
      //       ...prev,
      //       transplant_post_operative_complicationsEmpty: false,
      //     }));
      //   }
      //   break;


      //chk_thrombosis
      case "chk_thrombosis":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_post_operative_none_of_the_above: null,
            chk_portal_vein_thrombosis: false,
            chk_hepatic_artery_thrombosis: false,
            rbl_type_thrombosis_unknown: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      //chk_portal_vein_thrombosis
      case "chk_portal_vein_thrombosis":
      case "chk_hepatic_artery_thrombosis":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            chk_thrombosis: true,
            rbl_type_thrombosis_unknown: null,
            rbl_post_operative_none_of_the_above: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      // case "chk_hepatic_artery_thrombosis":
      //   {
      //     setTransplantDetails((prev) => ({
      //       ...prev,
      //       [name]: !prev[name],
      //       chk_thrombosis: true,
      //       rbl_type_thrombosis_unknown: null,
      //       rbl_post_operative_none_of_the_above: null,
      //     }));

      //     setHardErrList((prev) => ({
      //       ...prev,
      //       transplant_post_operative_complicationsEmpty: false,
      //     }));
      //   }
      //   break;

      case "rbl_type_thrombosis_unknown":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_thrombosis: true,
            chk_hepatic_artery_thrombosis: false,
            chk_portal_vein_thrombosis: false,
            rbl_post_operative_none_of_the_above: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      // case "chk_transfusion_operative_intervention":
      //   {
      //     setTransplantDetails((prev) => ({
      //       ...prev,
      //       [name]: !prev[name],
      //       rbl_post_operative_none_of_the_above: null,
      //     }));

      //     setHardErrList((prev) => ({
      //       ...prev,
      //       transplant_post_operative_complicationsEmpty: false,
      //     }));
      //   }
      //   break;

      //stricture

      case "chk_stricture":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_post_operative_none_of_the_above: null,
            chk_biliary_stricture: false,
            chk_portal_vein_stricture: false,
            chk_hepatic_artery_stricture: false,
            chk_hepatic_vein_stricture: false,
            rbl_type_stricture_unknown: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      case "chk_biliary_stricture":
      case "chk_portal_vein_stricture":
      case "chk_hepatic_artery_stricture":
      case "chk_hepatic_vein_stricture":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            chk_stricture: true,
            rbl_type_stricture_unknown: null,
            rbl_post_operative_none_of_the_above: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      // case "chk_hepatic_vein_stricture":
      //   {
      //     setTransplantDetails((prev) => ({
      //       ...prev,
      //       [name]: !prev[name],
      //       chk_stricture: true, //parent
      //       rbl_type_stricture_unknown: null, //child unk null
      //       rbl_post_operative_none_of_the_above: null, //parent unk null
      //     }));

      //     setHardErrList((prev) => ({
      //       ...prev,
      //       transplant_post_operative_complicationsEmpty: false,
      //     }));
      //   }
      //   break;

      case "rbl_type_stricture_unknown":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_stricture: true, //parent
            chk_biliary_stricture: false,
            chk_portal_vein_stricture: false,
            chk_hepatic_artery_stricture: false,
            chk_hepatic_vein_stricture: false,
            rbl_post_operative_none_of_the_above: null, //parent unk null
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      case "chk_infection":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_post_operative_none_of_the_above: null, //parent unk null
            chk_bacteremia_bloodstream_infection: false,
            chk_abdominal_wound_infection: false,
            chk_pneumonia_infection: false,
            chk_epstein_barr_virus_infection: false,
            chk_cytomegalovirus_infection: false,
            rbl_type_infection_unknown: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      case "chk_bacteremia_bloodstream_infection":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            chk_infection: true,
            rbl_type_infection_unknown: null,
            rbl_post_operative_none_of_the_above: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      case "chk_abdominal_wound_infection":
      case "chk_pneumonia_infection":
      case "chk_epstein_barr_virus_infection":
      case "chk_cytomegalovirus_infection":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            chk_infection: true,
            rbl_type_infection_unknown: null,
            rbl_post_operative_none_of_the_above: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      case "rbl_type_infection_unknown":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_infection: true, //parent
            chk_bacteremia_bloodstream_infection: false,
            chk_abdominal_wound_infection: false,
            chk_pneumonia_infection: false,
            chk_epstein_barr_virus_infection: false,
            chk_cytomegalovirus_infection: false,
            rbl_post_operative_none_of_the_above: null, //parent unk null
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      case "chk_post_operative_complications_other":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            txt_post_operative_complications: "",
            rbl_post_operative_none_of_the_above: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      case "txt_post_operative_complications":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: value,
            chk_post_operative_complications_other: true,
            rbl_post_operative_none_of_the_above: null,
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;

      case "rbl_post_operative_none_of_the_above":
        {
          setTransplantDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_acute_lactic_acidosis: false,
            chk_bile_leak: false,
            chk_thrombosis: false,
            chk_portal_vein_thrombosis: false,
            chk_hepatic_artery_thrombosis: false,
            rbl_type_thrombosis_unknown: null,
            chk_transfusion_operative_intervention: false,
            chk_stricture: false,
            chk_biliary_stricture: false,
            chk_portal_vein_stricture: false,
            chk_hepatic_artery_stricture: false,
            chk_hepatic_vein_stricture: false,
            rbl_type_stricture_unknown: null,
            chk_infection: false,
            chk_bacteremia_bloodstream_infection: false,
            chk_abdominal_wound_infection: false,
            chk_pneumonia_infection: false,
            chk_epstein_barr_virus_infection: false,
            chk_cytomegalovirus_infection: false,
            rbl_type_infection_unknown: null,
            chk_post_operative_complications_other: false,
            txt_post_operative_complications: "",
          }));

          setHardErrList((prev) => ({
            ...prev,
            transplant_post_operative_complicationsEmpty: false,
          }));
        }
        break;
      default:
        break;
    }
  };


  const HandleRepeaterDateChange = (name, date) => {
    
    const lastIndex = name.lastIndexOf("-");
    const id = name.slice(lastIndex + 1);

    switch (name) {

      case "transplant_lt_lkt_admission_dt-" + id:
        {
          let updatedArray = [...transplantRelatedHospitalization];

          updatedArray[id] = {
            ...updatedArray[id],
            transplant_lt_lkt_admission_dt: date,
            rbl_transplant_lt_lkt_admission: Values.value1,
            transplant_lt_lkt_admissionEmpty: false,
            transplant_admission_lt_lkt_dt_empty: false,
            transplant_admission_lt_lkt_dt_invalid: false,
          };


          setHardErrList((prev) => ({
            ...prev,
            earliest_lt_lkt_dt_Invalid: false,
            latest_lt_lkt_Invalid: false
          }));

          const validDates = updatedArray
          .map(entry => entry.transplant_lt_lkt_admission_dt)
          .filter(d => d);

          const earliestDate = validDates.length > 0 ? new Date(Math.min(...validDates.map(d => new Date(d)))) : null;

          if (earliestDate) {
          const transplantAdmissionMinusOne = AdjustDays(earliestDate, -Values.value1);
          let most_ClosestoneYrpriorIndex = DateValid(dates.beginning_follow_up, transplantAdmissionMinusOne);
          setClosestoneYrpriorIndex(most_ClosestoneYrpriorIndex);
          setTransplantAdDatechangeCount(true);
          }
          let formattedDate = DisplayFormat(earliestDate)
          setTransplantAdmissionHospDate(formattedDate);
          setTransplantRelatedHospitalization(updatedArray);
        }
        break;

      case "transplant_lt_lkt_discharge_dt-" + id:
        {
          let updatedArray = [...transplantRelatedHospitalization];
          updatedArray[id] = {
            ...updatedArray[id],
            transplant_lt_lkt_discharge_dt: date,
            rbl_transplant_lt_lkt_discharge: Values.value1,
            transplant_lt_lkt_dischargeEmpty: false,
            transplant_discharge_lt_lkt_dt_empty: false,
            transplant_discharge_lt_lkt_dt_invalid: false,
          };

          setHardErrList((prev) => ({
            ...prev,
            earliest_lt_lkt_dt_Invalid: false,
            latest_lt_lkt_Invalid: false
          }));

          const validDates = updatedArray
          .map(entry => entry.transplant_lt_lkt_discharge_dt)
          .filter(d => d);

        const latestDate = validDates.length > 0
          ? new Date(Math.max(...validDates.map(d => new Date(d))))
          : null;

        if (latestDate) {
          const transplantDischargePlusOne = AdjustDays(latestDate, Values.value1);
          let most_newClosest_threeMonthAfterIndex = IsGreaterOrEqual(dates.endofFollowUpDate, transplantDischargePlusOne);
          setnewClosest_threeMonthAfterIndex(most_newClosest_threeMonthAfterIndex);
          setTransplantDisDatechangeCount(true);
        }
          let formattedDate = DisplayFormat(latestDate)
        setTransplantDisDate(formattedDate);
          setTransplantRelatedHospitalization(updatedArray);
        }
        break;




      //transPlantvisit - admission

      case "transplant_visit_admission_dt-" + id:
        {
          let updatedArray = [...transplantVisitDetails];

          updatedArray[id].transplant_visit_admission_dt = date;
          updatedArray[id].rbl_transplant_visit_admission = 2;

          updatedArray[id].transplant_visit_admissionEmpty = false;
          updatedArray[id].transplant_admission_visit_dt_empty = false;
          updatedArray[id].transplant_admission_visit_dt_invalid = false;

          setTransplantVisitDetails(updatedArray);
        }
        break;

      case "transplant_visit_discharge_dt-" + id:
        {
          let updatedArray = [...transplantVisitDetails];

          updatedArray[id].transplant_visit_discharge_dt = date;
          updatedArray[id].rbl_transplant_visit_discharge = 2;

          updatedArray[id].transplant_visit_admissionEmpty = false;
          updatedArray[id].transplant_admission_visit_dt_empty = false;
          updatedArray[id].transplant_admission_visit_dt_invalid = false;

          setTransplantVisitDetails(updatedArray);
        }
        break;

      // transplant rejection
      case "transplant_rejection_start_dt-" + id:
        {
          let updatedArray = [...transplantRejectionDetails];

          updatedArray[id].transplant_rejection_start_dt = date;
          updatedArray[id].rbl_transplant_rejection_start = 2;

          updatedArray[id].transplant_rejection_startEmpty = false;
          updatedArray[id].transplant_rejection_start_dt_empty = false;
          updatedArray[id].transplant_rejection_start_dt_invalid = false;

          setTransplantRejectionDetails(updatedArray);
        }
        break;

      case "transplant_rejection_end_dt-" + id:
        {
          let updatedArray = [...transplantRejectionDetails];

          updatedArray[id].transplant_rejection_end_dt = date;
          updatedArray[id].rbl_transplant_rejection_end = 2;

          updatedArray[id].transplant_rejection_endEmpty = false;
          updatedArray[id].transplant_rejection_end_dt_empty = false;
          updatedArray[id].transplant_rejection_end_dt_invalid = false;

          setTransplantRejectionDetails(updatedArray);
        }
        break;

      //26
      case "transplant_hospitalization_dt-" + id:
        {
          let updatedArray = [...transplantHospitalizationDetails];

          updatedArray[id].transplant_hospitalization_dt = date;
          updatedArray[id].rbl_transplant_hospitalization = 2;

          updatedArray[id].rbl_transplant_hospitalizationEmpty = false;
          updatedArray[id].transplant_hospitalization_dt_empty = false;
          updatedArray[id].transplant_hospitalization_dt_invalid = false;

          setTransplantHospitalizationDetails(updatedArray);
        }
        break;


      //26 admission 
      case "transplant_kidney_admission_dt-" + id:
        {
          let updatedArray = [...transplantHospitalizationDetails];

          updatedArray[id].transplant_kidney_admission_dt = date;
          updatedArray[id].rbl_transplant_kidney_admission = 1;

          updatedArray[id].transplant_kidney_admissionEmpty = false;
          updatedArray[id].transplant_kidney_admission_dt_empty = false;
          updatedArray[id].transplant_kidney_admission_dt_invalid = false;

          setTransplantHospitalizationDetails(updatedArray);
        }
        break;

      //26 discharge
      case "transplant_kidney_discharge_dt-" + id:
        {
          let updatedArray = [...transplantHospitalizationDetails];

          updatedArray[id].transplant_kidney_discharge_dt = date;
          updatedArray[id].rbl_transplant_kidney_discharge = 1;

          updatedArray[id].transplant_kidney_dischargeEmpty = false;
          updatedArray[id].transplant_kidney_discharge_dt_empty = false;
          updatedArray[id].transplant_kidney_discharge_dt_invalid = false;

          setTransplantHospitalizationDetails(updatedArray);
        }
        break;


      default:
        break;
    }
  };

  const HandleRepeaterFieldChange = (e) => {

    const { name, id, value } = e.target;
    const value_int = Number(value);
    switch (name) {
      case "rbl_transplant_lt_lkt_admission" + id: {
        let updatedArray = [...transplantRelatedHospitalization];

        updatedArray[id].rbl_transplant_lt_lkt_admission = value_int;
        updatedArray[id].transplant_lt_lkt_admission_dt = null;
        updatedArray[id].chk_transplant_lt_lkt_admission_est = false;

        updatedArray[id].transplant_lt_lkt_admissionEmpty = false;
        updatedArray[id].transplant_admission_lt_lkt_dt_empty = false;
        updatedArray[id].transplant_admission_lt_lkt_dt_invalid = false;  
        setTransplantRelatedHospitalization(updatedArray);

        setHardErrList((prev) => ({
          ...prev,
          earliest_lt_lkt_dt_Invalid: false,
          latest_lt_lkt_Invalid: false
        }));

        const validDates = updatedArray
        .map(entry => entry.transplant_lt_lkt_admission_dt)
        .filter(d => d);

        const earliestDate = validDates.length > 0 ? new Date(Math.min(...validDates.map(d => new Date(d)))) : null;

        let formattedDate = DisplayFormat(earliestDate)
        setTransplantAdmissionHospDate(formattedDate);
        break;
      }

      case "chk_transplant_lt_lkt_admission_est" + id: {
        let updatedArray = [...transplantRelatedHospitalization];

        updatedArray[id].chk_transplant_lt_lkt_admission_est =
          !updatedArray[id].chk_transplant_lt_lkt_admission_est;
        updatedArray[id].rbl_transplant_lt_lkt_admission = Values.value1;

        updatedArray[id].transplant_lt_lkt_admissionEmpty = false;
        setTransplantRelatedHospitalization(updatedArray);
        break;
      }


      //discharge
      case "rbl_transplant_lt_lkt_discharge" + id: {
        let updatedArray = [...transplantRelatedHospitalization];

        updatedArray[id].rbl_transplant_lt_lkt_discharge = value_int;
        updatedArray[id].transplant_lt_lkt_discharge_dt = null;
        updatedArray[id].chk_transplant_lt_lkt_discharge_est = null;

        updatedArray[id].transplant_lt_lkt_dischargeEmpty = false;
        updatedArray[id].transplant_discharge_lt_lkt_dt_empty = false;
        updatedArray[id].transplant_discharge_lt_lkt_dt_invalid = false;
        setTransplantRelatedHospitalization(updatedArray);

        setHardErrList((prev) => ({
          ...prev,
          earliest_lt_lkt_dt_Invalid: false,
          latest_lt_lkt_Invalid: false
        }));

        
        const validDates = updatedArray
        .map(entry => entry.transplant_lt_lkt_discharge_dt)
        .filter(d => d);

      const latestDate = validDates.length > 0
        ? new Date(Math.max(...validDates.map(d => new Date(d))))
        : null;

        let formattedDate = DisplayFormat(latestDate)
          setTransplantDisDate(formattedDate);
        setTransplantRelatedHospitalization(updatedArray);

        break;
      }

      case "chk_transplant_lt_lkt_discharge_est" + id: {
        let updatedArray = [...transplantRelatedHospitalization];

        updatedArray[id].chk_transplant_lt_lkt_discharge_est =
          !updatedArray[id].chk_transplant_lt_lkt_discharge_est;
        updatedArray[id].rbl_transplant_lt_lkt_discharge = Values.value1;

        updatedArray[id].transplant_lt_lkt_dischargeEmpty = false;
        setTransplantRelatedHospitalization(updatedArray);
        break;
      }



      //visit type
      case "rbl_lt_lkt_visit_type" + id: {
        let updatedArray = [...transplantRelatedHospitalization];

        updatedArray[id].rbl_lt_lkt_visit_type = value_int;

        updatedArray[id].lt_lkt_visit_typeEmpty = false;
        setTransplantRelatedHospitalization(updatedArray);
        break;
      }


      case "rbl_transplant_visit_admission" + id: {
        let updatedArray = [...transplantVisitDetails];

        updatedArray[id].rbl_transplant_visit_admission = value_int;
        updatedArray[id].transplant_visit_admission_dt = null;
        updatedArray[id].chk_transplant_visit_admission_est = false;

        updatedArray[id].transplant_visit_admissionEmpty = false;
        updatedArray[id].transplant_admission_visit_dt_empty = false;
        updatedArray[id].transplant_admission_visit_dt_invalid = false;

        if (value_int === Values.value1) {
          updatedArray[id].rbl_transplant_visit_discharge = null;
          updatedArray[id].transplant_visit_discharge_dt = null;
          updatedArray[id].chk_transplant_visit_discharge_est = false;

          updatedArray[id].rbl_visit_type = null;

          updatedArray[id].transplant_visit_dischargeEmpty = false;
          updatedArray[id].transplant_discharge_visit_dt_empty = false;
          updatedArray[id].transplant_discharge_visit_dt_invalid = false;

          updatedArray[id].visit_typeEmpty = false;
        }
        //logic to remove rows except 1st if row1 has admission values as 1
        if (
          updatedArray[Values.value0].rbl_transplant_visit_admission ===
          Values.value1
        ) {
          updatedArray = [updatedArray[0]];
        }

        setTransplantVisitDetails(updatedArray);
        break;
      }

      case "chk_transplant_visit_admission_est" + id: {
        let updatedArray = [...transplantVisitDetails];

        updatedArray[id].chk_transplant_visit_admission_est =
          !updatedArray[id].chk_transplant_visit_admission_est;
        updatedArray[id].rbl_transplant_visit_admission = 2;

        updatedArray[id].transplant_visit_admissionEmpty = false;
        setTransplantVisitDetails(updatedArray);
        break;
      }

      //discharge
      case "rbl_transplant_visit_discharge" + id: {
        let updatedArray = [...transplantVisitDetails];

        updatedArray[id].rbl_transplant_visit_discharge = value_int;
        updatedArray[id].transplant_visit_discharge_dt = null;
        updatedArray[id].chk_transplant_visit_discharge_est = null;

        updatedArray[id].transplant_visit_dischargeEmpty = false;
        updatedArray[id].transplant_discharge_visit_dt_empty = false;
        updatedArray[id].transplant_discharge_visit_dt_invalid = false;
        setTransplantVisitDetails(updatedArray);
        break;
      }

      case "chk_transplant_visit_discharge_est" + id: {
        let updatedArray = [...transplantVisitDetails];

        updatedArray[id].chk_transplant_visit_discharge_est =
          !updatedArray[id].chk_transplant_visit_discharge_est;
        updatedArray[id].rbl_transplant_visit_discharge = 2;

        updatedArray[id].transplant_visit_dischargeEmpty = false;
        setTransplantVisitDetails(updatedArray);
        break;
      }

      //visit type
      case "rbl_visit_type" + id: {
        let updatedArray = [...transplantVisitDetails];

        updatedArray[id].rbl_visit_type = value_int;

        updatedArray[id].visit_typeEmpty = false;
        setTransplantVisitDetails(updatedArray);
        break;
      }

      //25 rejection

      case "rbl_transplant_rejection_start" + id: {
        let updatedArray = [...transplantRejectionDetails];

        updatedArray[id].rbl_transplant_rejection_start = value_int;
        updatedArray[id].transplant_rejection_start_dt = null;
        updatedArray[id].chk_transplant_rejection_start_est = false;

        updatedArray[id].transplant_rejection_startEmpty = false;
        updatedArray[id].transplant_rejection_start_dt_empty = false;
        updatedArray[id].transplant_rejection_start_dt_invalid = false;

        if (value_int === Values.value1) {
          updatedArray[id].rbl_transplant_rejection_end = null;
          updatedArray[id].transplant_rejection_end_dt = null;
          updatedArray[id].chk_transplant_rejection_end_est = false;

          updatedArray[id].rbl_rejection_type = null;

          updatedArray[id].transplant_rejection_endEmpty = false;
          updatedArray[id].transplant_rejection_end_dt_empty = false;
          updatedArray[id].transplant_rejection_end_dt_invalid = false;

          updatedArray[id].rejection_typeEmpty = false;
        }
        //logic to remove rows except 1st if  1st option selected in col 1
        if (
          updatedArray[Values.value0].rbl_transplant_rejection_start ===
          Values.value1
        ) {
          updatedArray = [updatedArray[0]];
        }

        setTransplantRejectionDetails(updatedArray);
        break;
      }

      case "chk_transplant_rejection_start_est" + id: {
        let updatedArray = [...transplantRejectionDetails];

        updatedArray[id].chk_transplant_rejection_start_est =
          !updatedArray[id].chk_transplant_rejection_start_est;
        updatedArray[id].rbl_transplant_rejection_start = 2;

        updatedArray[id].transplant_rejection_startEmpty = false;
        setTransplantRejectionDetails(updatedArray);
        break;
      }

      //discharge
      case "rbl_transplant_rejection_end" + id: {
        let updatedArray = [...transplantRejectionDetails];

        updatedArray[id].rbl_transplant_rejection_end = value_int;
        updatedArray[id].transplant_rejection_end_dt = null;
        updatedArray[id].chk_transplant_rejection_end_est = null;

        updatedArray[id].transplant_rejection_endEmpty = false;
        updatedArray[id].transplant_rejection_end_dt_empty = false;
        updatedArray[id].transplant_rejection_end_dt_invalid = false;
        setTransplantRejectionDetails(updatedArray);
        break;
      }

      case "chk_transplant_rejection_end_est" + id: {
        let updatedArray = [...transplantRejectionDetails];

        updatedArray[id].chk_transplant_rejection_end_est =
          !updatedArray[id].chk_transplant_rejection_end_est;
        updatedArray[id].rbl_transplant_rejection_end = 2;

        updatedArray[id].transplant_rejection_endEmpty = false;
        setTransplantRejectionDetails(updatedArray);
        break;
      }

      //visit type
      case "rbl_rejection_type" + id: {
        let updatedArray = [...transplantRejectionDetails];

        updatedArray[id].rbl_rejection_type = value_int;

        updatedArray[id].rejection_typeEmpty = false;
        setTransplantRejectionDetails(updatedArray);
        break;
      }



      //26


      case "rbl_transplant_hospitalization" + id: {
        let updatedArray = [...transplantHospitalizationDetails];

        updatedArray[id].rbl_transplant_hospitalization = value_int;
        updatedArray[id].transplant_hospitalization_dt = null;
        updatedArray[id].chk_transplant_hospitalization_est = false;
        updatedArray[id].rbl_transplant_hospitalizationEmpty = false;
        updatedArray[id].transplant_hospitalization_dt_empty = false
        updatedArray[id].transplant_hospitalization_dt_invalid = false

        if (value_int === Values.value1) {
          updatedArray[id].rbl_transplant_kidney_admission = null;
          updatedArray[id].transplant_kidney_admission_dt = null;
          updatedArray[id].chk_transplant_kidney_admission_est = false;


          updatedArray[id].rbl_transplant_kidney_discharge = null;
          updatedArray[id].transplant_kidney_discharge_dt = null;
          updatedArray[id].chk_transplant_kidney_discharge_est = false;

          updatedArray[id].rbl_part_lkt = null
          updatedArray[id].rbl_donor_type = null;
          updatedArray[id].rbl_procedure_type = null;
          updatedArray[id].rbl_kidney_location = null;

          updatedArray[id].transplant_kidney_admissionEmpty = false;
          updatedArray[id].transplant_kidney_admission_dt_empty = false;
          updatedArray[id].transplant_kidney_admission_dt_invalid = false;


          updatedArray[id].transplant_kidney_dischargeEmpty = false;
          updatedArray[id].transplant_kidney_discharge_dt_empty = false;
          updatedArray[id].transplant_kidney_discharge_dt_invalid = false;

          updatedArray[id].part_lktEmpty = false;
          updatedArray[id].transplant_donor_typeEmpty = false;
          updatedArray[id].transplant_procedure_typeEmpty = false;
          updatedArray[id].transplant_kidney_locationEmpty = false;
        }


        //logic to remove rows except 1st if  1st option selected in col 1
        if (
          updatedArray[Values.value0].rbl_transplant_hospitalization ===
          Values.value1
        ) {
          updatedArray = [updatedArray[0]];
        }

        setTransplantHospitalizationDetails(updatedArray);
        break;
      }


      case "chk_transplant_hospitalization_est" + id: {
        let updatedArray = [...transplantHospitalizationDetails];

        updatedArray[id].chk_transplant_hospitalization_est =
          !updatedArray[id].chk_transplant_hospitalization_est;
        updatedArray[id].rbl_transplant_hospitalization = 2;

        updatedArray[id].rbl_transplant_hospitalizationEmpty = false;
        setTransplantHospitalizationDetails(updatedArray);
        break;
      }


      //kidney admission
      case "rbl_transplant_kidney_admission" + id: {
        let updatedArray = [...transplantHospitalizationDetails];

        updatedArray[id].rbl_transplant_kidney_admission = value_int;
        updatedArray[id].transplant_kidney_admission_dt = null;
        updatedArray[id].chk_transplant_kidney_admission_est = null;

        updatedArray[id].transplant_kidney_admissionEmpty = false;
        updatedArray[id].transplant_kidney_admission_dt_empty = false;
        updatedArray[id].transplant_kidney_admission_dt_invalid = false;
        setTransplantHospitalizationDetails(updatedArray);
        break;
      }


      case "chk_transplant_kidney_admission_est" + id: {
        let updatedArray = [...transplantHospitalizationDetails];

        updatedArray[id].chk_transplant_kidney_admission_est =
          !updatedArray[id].chk_transplant_kidney_admission_est;
        updatedArray[id].rbl_transplant_kidney_admission = 1;

        updatedArray[id].transplant_kidney_admissionEmpty = false;
        setTransplantHospitalizationDetails(updatedArray);
        break;
      }



      //kidney discharge
      case "rbl_transplant_kidney_discharge" + id: {
        let updatedArray = [...transplantHospitalizationDetails];

        updatedArray[id].rbl_transplant_kidney_discharge = value_int;
        updatedArray[id].transplant_kidney_discharge_dt = null;
        updatedArray[id].chk_transplant_kidney_discharge_est = null;

        updatedArray[id].transplant_kidney_dischargeEmpty = false;
        updatedArray[id].transplant_kidney_discharge_dt_empty = false;
        updatedArray[id].transplant_kidney_discharge_dt_invalid = false;
        setTransplantHospitalizationDetails(updatedArray);
        break;
      }


      case "chk_transplant_kidney_discharge_est" + id: {
        let updatedArray = [...transplantHospitalizationDetails];

        updatedArray[id].chk_transplant_kidney_discharge_est =
          !updatedArray[id].chk_transplant_kidney_discharge_est;
        updatedArray[id].rbl_transplant_kidney_discharge = 1;

        updatedArray[id].transplant_kidney_dischargeEmpty = false;
        setTransplantHospitalizationDetails(updatedArray);
        break;
      }


      // part of LKT
      case "rbl_part_lkt" + id: {
        let updatedArray = [...transplantHospitalizationDetails];
        updatedArray[id].rbl_part_lkt = value_int;

        updatedArray[id].part_lktEmpty = false;
        setTransplantHospitalizationDetails(updatedArray);
        break;
      }



      // Donor type
      case "rbl_donor_type" + id: {
        let updatedArray = [...transplantHospitalizationDetails];
        updatedArray[id].rbl_donor_type = value_int;

        updatedArray[id].transplant_donor_typeEmpty = false;
        setTransplantHospitalizationDetails(updatedArray);
        break;
      }


      // Procedure type
      case "rbl_procedure_type" + id: {
        let updatedArray = [...transplantHospitalizationDetails];
        updatedArray[id].rbl_procedure_type = value_int;

        updatedArray[id].transplant_procedure_typeEmpty = false;

        if (value_int === Values.value2) {
          updatedArray[id].rbl_kidney_location = null;
          updatedArray[id].transplant_kidney_locationEmpty = false;
        }
        setTransplantHospitalizationDetails(updatedArray);
        break;
      }



      // kidney location
      case "rbl_kidney_location" + id: {
        let updatedArray = [...transplantHospitalizationDetails];
        updatedArray[id].rbl_kidney_location = value_int;

        updatedArray[id].transplant_kidney_locationEmpty = false;
        setTransplantHospitalizationDetails(updatedArray);
        break;
      }
      default:
        break;
    }
  };

//17
const DeleteTransplantLtLktRow = (id) => {
  const newArray = [...transplantRelatedHospitalization];
  newArray.splice(id, 1);
  setTransplantRelatedHospitalization(newArray);
};

const AddTransplantLtLktRow = () => {
  setTransplantRelatedHospitalization((prev) => [
    ...prev,
    {
      ...TransplantRelatedHospRow,
    },
  ]);
};




  const DeleteTransplantVisitRow = (id) => {
    const newArray = [...transplantVisitDetails];
    newArray.splice(id, 1);
    setTransplantVisitDetails(newArray);
  };

  const AddTransplantVisitRow = () => {
    setTransplantVisitDetails((prev) => [
      ...prev,
      {
        ...TransplantVisitRow,
      },
    ]);
  };

  //25
  const DeleteTransplantRejectionRow = (id) => {
    const newArray = [...transplantRejectionDetails];
    newArray.splice(id, 1);
    setTransplantRejectionDetails(newArray);
  };

  const AddTransplantRejectionRow = () => {
    setTransplantRejectionDetails((prev) => [
      ...prev,
      {
        ...TransplantRejectionRow,
      },
    ]);
  };


  //26
  const DeleteTransplantHospitalizationRow = (id) => {
    const newArray = [...transplantHospitalizationDetails];
    newArray.splice(id, 1);
    setTransplantHospitalizationDetails(newArray);
  };

  const AddTransplantHospitalizationRow = () => {
    setTransplantHospitalizationDetails((prev) => [
      ...prev,
      {
        ...TransplantHospitalizationRow,
      },
    ]);
  };
  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);


  const ShowAlertBox = async () => {
    await ShowActionPopUp(
      "Alert", //title
      CommonError_Msgs.DateChangeAlert, //message
      "Ok", //Confirm button text
      true
    );
  };

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div>
          <SideBarMenu activePageId={SideMenuItems.TransplantCharacteristics} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() =>
                toggleSidebar(isSideMenuActive, setisSideMenuActive)
              }
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left eligibiltylocked" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>TRANSPLANT CHARACTERISTICS</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div className="survey-question-section" >
                <div className="survey-question-content survey-content-box grey-bg">
                  <div className="question-answer">

                  <div className="block-border block-margin white-bg" style={{ marginBlock: "20px 0" }}>
                        <div>
                        <div className="question">
                            <span className="question-weight">Q17.</span>
                            <span className="quest-text-pad question-weight">
                              Please provide the admission and
                              discharge dates for the transplant-related
                              hospitalization during which the patient
                              underwent their LT/LKT procedure (
                              <span className="indigo-text">
                                {dates?.indexDt ?? "[index date]"}
                              </span>
                              ). Please follow the below guidelines for
                              defining these dates:
                            </span>
                          </div>
                          <br></br>
                          <span className="note-type question-weight">
                            <ul>
                              <li>
                                If the patient underwent a{" "}
                                <span
                                  data-tooltip-id="encounterTip"
                                  className="modal-popup"
                                  onClick={() =>
                                    setShowHideHyperlinkModal(true)
                                  }
                                >
                                  combined LKT,
                                </span>
                                {showHideHyperlinkModal && (
                                  <InfoPopUp
                                    description={hyperlinkTextCombinedLKT}
                                    OkClick={() =>
                                      setShowHideHyperlinkModal(false)
                                    }
                                  />
                                )}{" "}
                                please include the admission and discharge
                                date for the full procedure, as it is
                                expected that the liver and kidney(s) were
                                transplanted during the same
                                hospitalization.
                              </li>
                              <li>
                                If the patient underwent a{" "}
                                <span
                                  data-tooltip-id="encounterTip"
                                  className="modal-popup "
                                  onClick={() =>
                                    setShowHideHyperlinkModalSequential(
                                      true
                                    )
                                  }
                                >
                                  sequential LKT,
                                </span>
                                {showHideHyperlinkModalSequential && (
                                  <InfoPopUp
                                    description={
                                      hyperlinkTextSequentialLKT
                                    }
                                    OkClick={() =>
                                      setShowHideHyperlinkModalSequential(
                                        false
                                      )
                                    }
                                  />
                                )}{" "}
                                please include the admission and discharge
                                date for the liver transplant procedure
                                only (information on kidney transplants
                                will be collected separately).
                              </li>

                              <li>
                              If multiple care settings occurred (e.g., patient transferred from hospital to OR to ER to hospital, etc.), please list each care setting as an individual row with start and end dates specific for that setting of care
                              </li>

                              <li>Add additional rows for each hospitalization, ICU/NICU visit, ER visit, and OR admission, as needed.</li>
                            </ul>
                          </span>

                          <ErrorField
                                      show={
                                        hardErrList.latest_lt_lkt_Invalid || hardErrList.earliest_lt_lkt_dt_Invalid
                                      }
                                      message={CommonError_Msgs.Msg2}
                                    />
                                  
                        </div>
                        {transplantRelatedHospitalization &&
                          transplantRelatedHospitalization.length > 0 &&
                          transplantRelatedHospitalization.map((data, idx) => (
                            <div key={data.transplantltlktid} className="loop-section-ul">
                              <div className="loop-head">
                                <span className="question-weight">
                                  {GetOrdinal(idx + 1)} Transplant-related Hospitalization
                                </span>
                                {idx !== 0 && (
                                  <div className="delete-btn-div">
                                    <img
                                      width="16px"
                                      src="../Assets/images/Icon-material-delete.png"
                                      alt=""
                                      onClick={() =>
                                        DeleteTransplantLtLktRow(idx)
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                              <div className="containertd grid-overflow" colSpan={3}>
                                <table
                                  className="borderTable borderTable-custom"
                                  style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        className="table-th-sec"
                                      >
                                        Admission date{" "}
                                        <span className="indigo-text"></span>
                                      </th>
                                      <th
                                        className="table-th-sec"
                                      >
                                        Discharge date {" "}
                                        <span className="indigo-text"></span>
                                      </th>
                                      <th
                                        className="table-th-sec"
                                        style={{
                                          border: "1px solid",
                                          borderColor: "inherit",
                                          padding: "8px",
                                          textAlign: "center",
                                          minWidth: "360px",
                                        }}
                                      >
                                        Visit type{" "}
                                        <span className="indigo-text"></span>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        className="containertd"
                                        style={{
                                          borderBottom: "0",
                                        }}
                                      >
                                        <>
                                       
                                
                                          
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "rbl_transplant_lt_lkt_admission" +
                                                  idx
                                                }
                                                value={1}
                                                checked={
                                                  data.rbl_transplant_lt_lkt_admission ===
                                                 Values.value1
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />
                                              <span className="date-field-padding-left">
                                                <DateControl
                                                  ctrlId={
                                                    "transplant_lt_lkt_admission_dt-" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  date={
                                                    data.transplant_lt_lkt_admission_dt
                                                  }
                                                />
                                              </span>
                                            </label>
                                          </div>

                                          <div className="estimated-date-padding text-margin">
                                            <label>
                                              <input
                                                type="checkbox"
                                                id={idx}
                                                name={
                                                  "chk_transplant_lt_lkt_admission_est" +
                                                  idx
                                                }
                                                checked={
                                                  data.chk_transplant_lt_lkt_admission_est
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />
                                              <span className="radio-text-padding">
                                                Estimated Date
                                              </span>
                                            </label>
                                          </div>

                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "rbl_transplant_lt_lkt_admission" +
                                                  idx
                                                }
                                                value={99}
                                                checked={
                                                  data.rbl_transplant_lt_lkt_admission ===
                                                  Values.value99
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />
                                              <span className="radio-text-padding">
                                                Date Unknown
                                              </span>
                                            </label>
                                          </div>
                                          <ErrorField
                                            show={
                                              data.transplant_lt_lkt_admissionEmpty
                                            }
                                            message={
                                              CommonError_Msgs.Msg1
                                            }
                                          />
                                          <ErrorField
                                            show={
                                              data.transplant_admission_lt_lkt_dt_empty ||
                                              data.transplant_admission_lt_lkt_dt_invalid
                                            }
                                            message={
                                              CommonError_Msgs.Msg2
                                            }
                                          />
                                        </>
                                      </td>
                                      <td
                                        className="containertd"
                                        style={{
                                          borderBottom: "0",
                                        }}
                                      >
                                    
                                          <>
                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_transplant_lt_lkt_discharge" +
                                                    idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.rbl_transplant_lt_lkt_discharge ===
                                                    Values.value1
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="date-field-padding-left">
                                                  <DateControl
                                                    ctrlId={
                                                      "transplant_lt_lkt_discharge_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    date={
                                                      data.transplant_lt_lkt_discharge_dt
                                                    }
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div className="estimated-date-padding text-margin">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={
                                                    "chk_transplant_lt_lkt_discharge_est" +
                                                    idx
                                                  }
                                                  checked={
                                                    data.chk_transplant_lt_lkt_discharge_est
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Estimated Date
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_transplant_lt_lkt_discharge" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    data.rbl_transplant_lt_lkt_discharge ===
                                                    Values.value99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Date Unknown
                                                </span>
                                              </label>
                                              <ErrorField
                                                show={
                                                  data.transplant_lt_lkt_dischargeEmpty
                                                }
                                                message={
                                                  CommonError_Msgs.Msg1
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  data.transplant_discharge_lt_lkt_dt_empty ||
                                                  data.transplant_discharge_lt_lkt_dt_invalid
                                                }
                                                message={
                                                  CommonError_Msgs.Msg2
                                                }
                                              />
                                            </div>
                                          </>
                                        
                                      </td>
                                      <td className="containertd">
                                 
                                          <div className="">
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_lt_lkt_visit_type" +
                                                    idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.rbl_lt_lkt_visit_type ===
                                                    Values.value1
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  OR admission
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_lt_lkt_visit_type" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={
                                                    data.rbl_lt_lkt_visit_type ===
                                                    Values.value2
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  ICU/NICU visit
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_lt_lkt_visit_type" +
                                                    idx
                                                  }
                                                  value={3}
                                                  checked={
                                                    data.rbl_lt_lkt_visit_type ===
                                                    Values.value3
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  ER visit
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_lt_lkt_visit_type" +
                                                    idx
                                                  }
                                                  value={4}
                                                  checked={
                                                    data.rbl_lt_lkt_visit_type ===
                                                    Values.value4
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Hospitalization
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                data.lt_lkt_visit_typeEmpty
                                              }
                                              message={
                                                CommonError_Msgs.Msg1
                                              }
                                            />
                                          </div>
                                       
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ))}

                        {transplantRelatedHospitalization && patientLocked===false && (
                            <div className="sub-question-bot-sapce-ul mt-2">
                              <div className="answer-list-text">
                                <a
                                  onClick={AddTransplantLtLktRow}
                                 
                                >
                                   <img
                                    width="18px"
                                    src="../Assets/images/plus.png"
                                    alt=""
                                  />
                                </a>
                                 <a  className="radio-text-padding"
                                 onClick={AddTransplantLtLktRow}
                                 >Click here to add another transplant related hospitalization 
                                 
                                 </a> 
                              </div>
                            </div>
                          )}

                      </div>

                    {/* 1818 */}
                    <div className="block-border white-bg" style={{ marginBlock: "20px 0" }}>
                      <div>
                        <div className="custom-table custom-table-col grid-overflow">

                          <span className="question-weight">Q18.</span>
                          <span className="quest-text-pad question-weight">
                            Please provide additional
                            characteristics specific to the patient’s
                            liver transplant.
                          </span>

                          <div className="custom-table grid-overflow">

                            <table
                              style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}
                              className="borderTable"
                            >
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      borderRight: "1px solid",
                                      borderColor: "inherit",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "150px",
                                    }}
                                  >
                                    Donor status{" "}
                                    <span className="indigo-text"></span>
                                  </th>
                                  <th
                                    style={{
                                      borderRight: "1px solid",
                                      borderColor: "inherit",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "200px",
                                    }}
                                  >
                                    Donor disease history{" "}
                                    <span className="indigo-text"></span>
                                  </th>
                                  <th
                                    style={{
                                      borderRight: "1px solid",
                                      borderColor: "inherit",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "200px",
                                    }}
                                  >
                                    Donor’s relation to patient{" "}
                                    <span className="indigo-text"></span>
                                  </th>
                                  <th
                                    style={{
                                      borderRight: "1px solid",
                                      borderColor: "inherit",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "200px",
                                    }}
                                  >
                                    State of organ received{" "}
                                    <span className="indigo-text"></span>
                                  </th>

                                  <th
                                    style={{
                                      borderRight: "1px solid",
                                      borderColor: "inherit",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "200px",
                                    }}
                                  >
                                    Auxiliary transplant{" "}
                                    <span className="indigo-text"></span>
                                  </th>



                                  <th
                                    style={{
                                      borderRight: "1px solid",
                                      borderColor: "inherit",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "200px",
                                    }}
                                  >
                                    Lobe received{" "}
                                    <span className="indigo-text"></span>
                                  </th>

                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  {/* 1 */}
                                  <td className="modal-popup-table-cell">
                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_status_1"
                                          name="rbl_donor_status"
                                          value={1}
                                          checked={
                                            transplantDetails.rbl_donor_status ===
                                            Values.value1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">Living</span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_status_2"
                                          name="rbl_donor_status"
                                          value={2}
                                          checked={
                                            transplantDetails.rbl_donor_status ===
                                            Values.value2
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">Deceased</span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_status_99"
                                          name="rbl_donor_status"
                                          value={99}
                                          checked={
                                            transplantDetails.rbl_donor_status ===
                                            Values.value99
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">Unknown</span>
                                      </label>
                                    </div>
                                    <ErrorField
                                      show={
                                        hardErrList.rbl_donor_statusEmpty
                                      }
                                      message={CommonError_Msgs.Msg1}
                                    />
                                  </td>
                                  {/* 2 */}
                                  <td className="modal-popup-table-cell">
                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_disease_hist1"
                                          name="rbl_donor_disease_hist"
                                          value={1}
                                          checked={
                                            transplantDetails.rbl_donor_disease_hist ===
                                            Values.value1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">
                                          Donor with <i>mut</i> heterozygous
                                        </span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_disease_hist2"
                                          name="rbl_donor_disease_hist"
                                          value={2}
                                          checked={
                                            transplantDetails.rbl_donor_disease_hist ===
                                            Values.value2
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">
                                          Donor with <i>mut</i> homozygous
                                        </span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_disease_hist3"
                                          name="rbl_donor_disease_hist"
                                          value={3}
                                          checked={
                                            transplantDetails.rbl_donor_disease_hist ===
                                            Values.value3
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">
                                          Donor with non-<i>mut</i> MMA
                                        </span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_disease_hist4"
                                          name="rbl_donor_disease_hist"
                                          value={4}
                                          checked={
                                            transplantDetails.rbl_donor_disease_hist ===
                                            Values.value4
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">
                                          Donor without MMA
                                        </span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_disease_hist99"
                                          name="rbl_donor_disease_hist"
                                          value={99}
                                          checked={
                                            transplantDetails.rbl_donor_disease_hist ===
                                            Values.value99
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">Unknown</span>
                                      </label>
                                    </div>
                                    <ErrorField
                                      show={
                                        hardErrList.rbl_donor_disease_histEmpty
                                      }
                                      message={CommonError_Msgs.Msg1}
                                    />
                                  </td>

                                  {/* 3 */}
                                  <td className="modal-popup-table-cell">
                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_relation1"
                                          name="rbl_donor_relation"
                                          value={1}
                                          checked={
                                            transplantDetails.rbl_donor_relation ===
                                            Values.value1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">
                                          Relative or kin
                                        </span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_relation2"
                                          name="rbl_donor_relation"
                                          value={2}
                                          checked={
                                            transplantDetails.rbl_donor_relation ===
                                            Values.value2
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">
                                          Not relative or kin
                                        </span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_donor_relation99"
                                          name="rbl_donor_relation"
                                          value={99}
                                          checked={
                                            transplantDetails.rbl_donor_relation ===
                                            Values.value99
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">Unknown</span>
                                      </label>
                                    </div>
                                    <ErrorField
                                      show={
                                        hardErrList.rbl_donor_relationEmpty
                                      }
                                      message={CommonError_Msgs.Msg1}
                                    />
                                  </td>

                                  {/* 4 */}
                                  <td className="modal-popup-table-cell">
                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_state_organ_rcvd1"
                                          name="rbl_state_organ_rcvd"
                                          value={1}
                                          checked={
                                            transplantDetails.rbl_state_organ_rcvd ===
                                            Values.value1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">Full organ</span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_state_organ_rcvd2"
                                          name="rbl_state_organ_rcvd"
                                          value={2}
                                          checked={
                                            transplantDetails.rbl_state_organ_rcvd ===
                                            Values.value2
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">
                                          Partial organ
                                        </span>
                                      </label>
                                    </div>

                                    <div className="date-field-padding">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id="rbl_state_organ_rcvd99"
                                          name="rbl_state_organ_rcvd"
                                          value={99}
                                          checked={
                                            transplantDetails.rbl_state_organ_rcvd ===
                                            Values.value99
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="">Unknown</span>
                                      </label>
                                    </div>
                                    <ErrorField
                                      show={
                                        hardErrList.rbl_state_organ_rcvdEmpty
                                      }
                                      message={CommonError_Msgs.Msg1}
                                    />
                                  </td>
                                  {/* 5 */}
                                  {transplantDetails.rbl_state_organ_rcvd ===
                                    Values.value1 ? (
                                    <td>
                                      <p
                                        style={{ textAlign: "center", marginBottom: "0" }}
                                      >
                                        <b>Not Applicable</b>
                                      </p>
                                    </td>
                                  ) : (
                                    <td className="modal-popup-table-cell">
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="rbl_auxillary_transplant1"
                                            name="rbl_auxillary_transplant"
                                            value={1}
                                            checked={
                                              transplantDetails.rbl_auxillary_transplant ===
                                              Values.value1
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="">Yes</span>
                                        </label>
                                      </div>

                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="rbl_auxillary_transplant0"
                                            name="rbl_auxillary_transplant"
                                            value={0}
                                            checked={
                                              transplantDetails.rbl_auxillary_transplant ===
                                              Values.value0
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="">No</span>
                                        </label>
                                      </div>

                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="rbl_auxillary_transplant99"
                                            name="rbl_auxillary_transplant"
                                            value={99}
                                            checked={
                                              transplantDetails.rbl_auxillary_transplant ===
                                              Values.value99
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="">Unknown</span>
                                        </label>
                                      </div>
                                      <ErrorField
                                        show={
                                          hardErrList.rbl_auxillary_transplantEmpty
                                        }
                                        message={CommonError_Msgs.Msg1}
                                      />
                                    </td>
                                  )}

                                  {/* 6 */}
                                  {transplantDetails.rbl_state_organ_rcvd ===
                                    Values.value1 ? (
                                    <td>
                                      <p
                                        style={{
                                          textAlign: "center",
                                          marginBottom: "0"
                                        }}
                                      >
                                        <b>Not Applicable</b>
                                      </p>
                                    </td>
                                  ) : (
                                    <td className="modal-popup-table-cell">
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="rbl_lobe_rcvd1"
                                            name="rbl_lobe_rcvd"
                                            value={1}
                                            checked={
                                              transplantDetails.rbl_lobe_rcvd ===
                                              Values.value1
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="">
                                            Left lobe
                                          </span>
                                        </label>
                                      </div>

                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="rbl_lobe_rcvd2"
                                            name="rbl_lobe_rcvd"
                                            value={2}
                                            checked={
                                              transplantDetails.rbl_lobe_rcvd ===
                                              Values.value2
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="">
                                            Right lobe
                                          </span>
                                        </label>
                                      </div>

                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="rbl_lobe_rcvd99"
                                            name="rbl_lobe_rcvd"
                                            value={99}
                                            checked={
                                              transplantDetails.rbl_lobe_rcvd ===
                                              Values.value99
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="">Unknown</span>
                                        </label>
                                      </div>
                                      <ErrorField
                                        show={
                                          hardErrList.rbl_lobe_rcvdEmpty
                                        }
                                        message={CommonError_Msgs.Msg1}
                                      />
                                    </td>
                                  )}
                                </tr>
                              </tbody>
                            </table>

                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 1919 */}
                    <div className="block-margin white-bg" style={{ marginBlock: "20px 0" }}>
                      <div>
                        <div className="custom-table custom-table-col grid-overflow">
                          <table  style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}>
                            {/* 19 */}
                            <tr>
                              <td className="containertd">
                                <div className="question">
                                  <span className="question-weight">Q19.</span>
                                  <span className="quest-text-pad question-weight">
                                    Please provide the liver graft weight
                                  </span>
                                </div>
                              </td>
                              <td className="containertd">
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      type="radio"
                                      id="rbl_liver_graft_weight1"
                                      name="rbl_liver_graft_weight"
                                      value={1}
                                      checked={
                                        transplantDetails.rbl_liver_graft_weight ===
                                        Values.value1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <input
                                      className="input-dash input-width-dash"
                                      type="text"
                                      id="liver_graft_weight_value_oz"
                                      name="liver_graft_weight_value_oz"
                                      value={
                                        transplantDetails.liver_graft_weight_value_oz
                                      }
                                      onChange={HandleFieldChange}
                                      maxLength={8}
                                    />
                                    <span>oz</span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      type="radio"
                                      id="rbl_liver_graft_weight2"
                                      name="rbl_liver_graft_weight"
                                      value={2}
                                      checked={
                                        transplantDetails.rbl_liver_graft_weight ===
                                        Values.value2
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <input
                                      className="input-dash input-width-dash"
                                      type="text"
                                      id="liver_graft_weight_value_lbs"
                                      name="liver_graft_weight_value_lbs"
                                      value={
                                        transplantDetails.liver_graft_weight_value_lbs
                                      }
                                      onChange={HandleFieldChange}
                                      maxLength={8}
                                    />
                                    <span>lbs</span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      type="radio"
                                      id="rbl_liver_graft_weight3"
                                      name="rbl_liver_graft_weight"
                                      value={3}
                                      checked={
                                        transplantDetails.rbl_liver_graft_weight ===
                                        Values.value3
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <input
                                      className="input-dash input-width-dash"
                                      type="text"
                                      id="liver_graft_weight_value_g"
                                      name="liver_graft_weight_value_g"
                                      value={
                                        transplantDetails.liver_graft_weight_value_g
                                      }
                                      onChange={HandleFieldChange}
                                      maxLength={8}
                                    />
                                    <span>g</span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      type="radio"
                                      id="rbl_liver_graft_weight4"
                                      name="rbl_liver_graft_weight"
                                      value={4}
                                      checked={
                                        transplantDetails.rbl_liver_graft_weight ===
                                        Values.value4
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <input
                                      className="input-dash input-width-dash"
                                      type="text"
                                      id="liver_graft_weight_value_kg"
                                      name="liver_graft_weight_value_kg"
                                      value={
                                        transplantDetails.liver_graft_weight_value_kg
                                      }
                                      onChange={HandleFieldChange}
                                      maxLength={8}
                                    />
                                    <span>kg</span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      type="radio"
                                      id="rbl_liver_graft_weight99"
                                      name="rbl_liver_graft_weight"
                                      value={99}
                                      checked={
                                        transplantDetails.rbl_liver_graft_weight ===
                                        Values.value99
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>Unknown</span>
                                  </label>
                                </div>
                                <ErrorField
                                  show={hardErrList.rbl_liver_graft_weightEmpty}
                                  message={CommonError_Msgs.Msg1}
                                />
                                <ErrorField
                                  show={hardErrList.rbl_liver_graft_weight_valueEmpty}
                                  message={CommonError_Msgs.Msg1}
                                />


                                <ErrorField
                                  show={hardErrList.rbl_liver_graft_weight_invalid}
                                  message={CommonError_Msgs.Msg2}
                                />
                              </td>
                            </tr>
                            {/* 20 */}
                            <tr>
                              <td className="containertd">
                                <div className="question">
                                  <span className="question-weight">Q20.</span>
                                  <span className="quest-text-pad question-weight">
                                    Please indicate if any of the following were
                                    used within the LT transplant hospitalization period
                                    (from{" "}
                                    <span className="indigo-text">
                                      {transplantDetails.transplant_admission_dt || "transplant admission date"}
                                    </span>{" "}
                                    to{" "}
                                    <span className="indigo-text">
                                      {transplantDetails.transplant_discharge_dt || "transplant discharge date"}
                                    </span>
                                    ).{" "}
                                    <i>Select all that apply.</i>
                                  </span>
                                </div>
                              </td>
                              <td className="containertd">
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      className="custom-top-spacing"
                                      type="checkbox"
                                      id="chk_primary_abdominal_closure"
                                      name="chk_primary_abdominal_closure"
                                      checked={
                                        transplantDetails.chk_primary_abdominal_closure
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>Primary abdominal closure</span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      className="custom-top-spacing"
                                      type="checkbox"
                                      id="chk_induction_immunosuppression_therapy"
                                      name="chk_induction_immunosuppression_therapy"
                                      checked={
                                        transplantDetails.chk_induction_immunosuppression_therapy
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>
                                      Induction immunosuppression therapy
                                    </span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      type="radio"
                                      id="rbl_lt_procedure_none_Unk1"
                                      name="rbl_lt_procedure_none_Unk"
                                      value={1}
                                      checked={
                                        transplantDetails.rbl_lt_procedure_none_Unk ===
                                        Values.value1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>None of the above</span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      type="radio"
                                      id="rbl_lt_procedure_none_Unk99"
                                      name="rbl_lt_procedure_none_Unk"
                                      value={99}
                                      checked={
                                        transplantDetails.rbl_lt_procedure_none_Unk ===
                                        Values.value99
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>Unknown</span>
                                  </label>
                                </div>
                                <ErrorField
                                  show={hardErrList.indicate_LT_ProcedureEmpty}
                                  message={CommonError_Msgs.Msg1}
                                />
                              </td>
                            </tr>
                            {/* 21 */}
                            <tr>
                              <td className="containertd">
                                <div className="question">
                                  <span className="question-weight">Q21.</span>
                                  <span className="quest-text-pad question-weight">
                                    Please report which, if any, of the
                                    following renal replacement treatments were
                                    reported being used{" "}
                                    <u>outside of MDEs only</u> within the{" "}
                                    <u>LT transplant hospitalization period</u>{" "}
                                    (from{" "}
                                    <span className="indigo-text">
                                      {transplantDetails.transplant_admission_dt || "transplant admission date"}
                                    </span>{" "}
                                    to{" "}
                                    <span className="indigo-text">
                                      {transplantDetails.transplant_discharge_dt || "transplant discharge date"}
                                    </span>
                                    ). <i>Select all that apply.</i>
                                  </span>
                                </div>
                              </td>
                              <td className="containertd">
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      className="custom-top-spacing"
                                      type="checkbox"
                                      id="chk_hemodialysis"
                                      name="chk_hemodialysis"
                                      checked={
                                        transplantDetails.chk_hemodialysis
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>Hemodialysis</span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      className="custom-top-spacing"
                                      type="checkbox"
                                      id="chk_hemodiafiltration_hemofiltration"
                                      name="chk_hemodiafiltration_hemofiltration"
                                      checked={
                                        transplantDetails.chk_hemodiafiltration_hemofiltration
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>
                                      Hemodiafiltration or hemofiltration
                                    </span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      className="custom-top-spacing"
                                      type="checkbox"
                                      id="chk_peritoneal_dialysis"
                                      name="chk_peritoneal_dialysis"
                                      checked={
                                        transplantDetails.chk_peritoneal_dialysis
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>Peritoneal dialysis</span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      type="radio"
                                      id="rbl_renal_replacement_none_unk1"
                                      name="rbl_renal_replacement_none_unk"
                                      value={1}
                                      checked={
                                        transplantDetails.rbl_renal_replacement_none_unk ===
                                        Values.value1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>None of the above</span>
                                  </label>
                                </div>
                                <div>
                                  <label className="option-fbox">
                                    <input
                                      type="radio"
                                      id="rbl_renal_replacement_none_unk99"
                                      name="rbl_renal_replacement_none_unk"
                                      value={99}
                                      checked={
                                        transplantDetails.rbl_renal_replacement_none_unk ===
                                        Values.value99
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span>Unknown</span>
                                  </label>
                                </div>
                                <ErrorField
                                  show={hardErrList.renal_replacementEmpty}
                                  message={CommonError_Msgs.Msg1}
                                />
                              </td>
                            </tr>
                            {/* 22 */}
                            <tr>

                              <td className="containertd custom-left-border-disabled custom-bottom-border-disabled relative-position">
                                <div className="question">
                                  <span className="question-weight">Q22.</span>
                                  <span className="quest-text-pad question-weight">
                                    Please indicate the infection status of the
                                    patient and liver donor, if available,{" "}
                                    <u>at the time of the LT procedure</u> (
                                    <span className="indigo-text">
                                      {dates?.indexDt ?? "[index date]"}
                                    </span>
                                    ). <i>Select all that apply.</i>
                                  </span>
                                </div>
                              </td>
                              <td className="padding-zero">
                                <table className="nested-table"  style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}>
                                  <tr>
                                    <th className="custom-enhanced-padding">
                                      Liver recipient (i.e., study patient)
                                    </th>
                                    <th className="custom-enhanced-padding">Liver donor</th>
                                  </tr>
                                  <tr>
                                    <td className="containertd relative-position">
                                      <div className="">
                                        <div>
                                          <label className="option-fbox">
                                            <input
                                              className="custom-top-spacing"
                                              type="checkbox"
                                              id="chk_liver_recipient_EBV"
                                              name="chk_liver_recipient_EBV"
                                              checked={
                                                transplantDetails.chk_liver_recipient_EBV
                                              }
                                              onChange={HandleFieldChange}
                                            />
                                            <span>
                                              Epstein–Barr virus (EBV) infection
                                            </span>
                                          </label>
                                        </div>
                                        <div>
                                          <label className="option-fbox">
                                            <input
                                              className="custom-top-spacing"
                                              type="checkbox"
                                              id="chk_liver_recipient_CMV"
                                              name="chk_liver_recipient_CMV"
                                              checked={
                                                transplantDetails.chk_liver_recipient_CMV
                                              }
                                              onChange={HandleFieldChange}
                                            />
                                            <span>
                                              Cytomegalovirus (CMV) infection
                                            </span>
                                          </label>
                                        </div>
                                        <div>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id="rbl_liver_recipient_none_Unk1"
                                              name="rbl_liver_recipient_none_Unk"
                                              value={1}
                                              checked={
                                                transplantDetails.rbl_liver_recipient_none_Unk ===
                                                1
                                              }
                                              onChange={HandleFieldChange}
                                            />
                                            <span>None of the above</span>
                                          </label>
                                        </div>
                                        <div>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id="rbl_liver_recipient_none_Unk99"
                                              name="rbl_liver_recipient_none_Unk"
                                              value={99}
                                              checked={
                                                transplantDetails.rbl_liver_recipient_none_Unk ===
                                                99
                                              }
                                              onChange={HandleFieldChange}
                                            />
                                            <span>Unknown</span>
                                          </label>
                                        </div>
                                      </div>
                                      <ErrorField
                                        show={hardErrList.liver_recipientEmpty}
                                        message={CommonError_Msgs.Msg1}
                                      />
                                    </td>

                                    <td className="containertd">
                                      <div className="">
                                        <div>
                                          <label className="option-fbox">
                                            <input
                                              className="custom-top-spacing"
                                              type="checkbox"
                                              id="chk_liver_donor_EBV"
                                              name="chk_liver_donor_EBV"
                                              checked={
                                                transplantDetails.chk_liver_donor_EBV
                                              }
                                              onChange={HandleFieldChange}
                                            />
                                            <span>
                                              Epstein–Barr virus (EBV) infection
                                            </span>
                                          </label>
                                        </div>
                                        <div>
                                          <label className="option-fbox">
                                            <input
                                              className="custom-top-spacing"
                                              type="checkbox"
                                              id="chk_liver_donor_CMV"
                                              name="chk_liver_donor_CMV"
                                              checked={
                                                transplantDetails.chk_liver_donor_CMV
                                              }
                                              onChange={HandleFieldChange}
                                            />
                                            <span>
                                              Cytomegalovirus (CMV) infection
                                            </span>
                                          </label>
                                        </div>
                                        <div>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id="rbl_liver_donor_none_Unk1"
                                              name="rbl_liver_donor_none_Unk"
                                              value={1}
                                              checked={
                                                transplantDetails.rbl_liver_donor_none_Unk ===
                                                1
                                              }
                                              onChange={HandleFieldChange}
                                            />
                                            <span>None of the above</span>
                                          </label>
                                        </div>
                                        <div>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id="rbl_liver_donor_none_Unk99"
                                              name="rbl_liver_donor_none_Unk"
                                              value={99}
                                              checked={
                                                transplantDetails.rbl_liver_donor_none_Unk ===
                                                99
                                              }
                                              onChange={HandleFieldChange}
                                            />
                                            <span>Unknown</span>
                                          </label>
                                        </div>
                                      </div>
                                      <ErrorField
                                        show={hardErrList.liver_donorEmpty}
                                        message={CommonError_Msgs.Msg1}
                                      />
                                    </td>
                                  </tr>
                                </table>
                              </td>


                            </tr>
                            {/* 23 */}
                            <tr>
                              <td className="containertd">
                                <div className="question">
                                  <span className="question-weight">Q23.</span>
                                  <span className="quest-text-pad question-weight">
                                    Please indicate which LT/LKT transplant
                                    post-operative complications occurred{" "}
                                    <u>within the LT transplant hospitalization period and within 3 months on or after</u> the index
                                    date (from{" "}
                                    <span className="indigo-text">
                                      {transplantDetails.transplant_admission_dt || "transplant admission date"}
                                    </span>{" "}
                                    to{" "}
                                    <span className="indigo-text">
                                      {dates?.three_month_stabilization ?? "3-month stabilization date"}
                                    </span>
                                    ). <i>Select all that apply.</i>
                                  </span>
                                </div>
                              </td>

                              <td className="containertd">
                                <div className="">
                                  <div>
                                    <label className="long-text-option">
                                      <input
                                        type="checkbox"
                                        id="chk_acute_lactic_acidosis"
                                        name="chk_acute_lactic_acidosis"
                                        checked={
                                          transplantDetails.chk_acute_lactic_acidosis
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Acute lactic acidosis
                                      </span>
                                    </label>
                                  </div>
                                  <div>
                                    <label className="long-text-option">
                                      <input
                                        type="checkbox"
                                        id="chk_bile_leak"
                                        name="chk_bile_leak"
                                        checked={
                                          transplantDetails.chk_bile_leak
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Bile leak
                                      </span>
                                    </label>
                                  </div>

                                  <div>
                                    <label className="long-text-option">
                                      <input
                                        type="checkbox"
                                        id="chk_thrombosis"
                                        name="chk_thrombosis"
                                        checked={
                                          transplantDetails.chk_thrombosis
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Thrombosis
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_portal_vein_thrombosis"
                                        name="chk_portal_vein_thrombosis"
                                        checked={
                                          transplantDetails.chk_portal_vein_thrombosis
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Portal vein thrombosis
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_hepatic_artery_thrombosis"
                                        name="chk_hepatic_artery_thrombosis"
                                        checked={
                                          transplantDetails.chk_hepatic_artery_thrombosis
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Hepatic artery thrombosis
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="radio"
                                        id="rbl_type_thrombosis_unknown99"
                                        name="rbl_type_thrombosis_unknown"
                                        value={99}
                                        checked={
                                          transplantDetails.rbl_type_thrombosis_unknown ===
                                          Values.value99
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Type of thrombosis unknown
                                      </span>
                                    </label>
                                  </div>

                                  <div>
                                    <label className="long-text-option">
                                      <input
                                        type="checkbox"
                                        id="chk_transfusion_operative_intervention"
                                        name="chk_transfusion_operative_intervention"
                                        checked={
                                          transplantDetails.chk_transfusion_operative_intervention
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Clinically significant bleeding (i.e.,
                                        requiring transfusion/operative
                                        intervention)
                                      </span>
                                    </label>
                                  </div>

                                  <div>
                                    <label className="long-text-option">
                                      <input
                                        type="checkbox"
                                        id="chk_stricture"
                                        name="chk_stricture"
                                        checked={
                                          transplantDetails.chk_stricture
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Stricture
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_biliary_stricture"
                                        name="chk_biliary_stricture"
                                        checked={
                                          transplantDetails.chk_biliary_stricture
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Biliary stricture
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_portal_vein_stricture"
                                        name="chk_portal_vein_stricture"
                                        checked={
                                          transplantDetails.chk_portal_vein_stricture
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Portal vein stricture
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_hepatic_artery_stricture"
                                        name="chk_hepatic_artery_stricture"
                                        checked={
                                          transplantDetails.chk_hepatic_artery_stricture
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Hepatic artery stricture
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_hepatic_vein_stricture"
                                        name="chk_hepatic_vein_stricture"
                                        checked={
                                          transplantDetails.chk_hepatic_vein_stricture
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Hepatic vein stricture
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="radio"
                                        id="rbl_type_stricture_unknown99"
                                        name="rbl_type_stricture_unknown"
                                        value={99}
                                        checked={
                                          transplantDetails.rbl_type_stricture_unknown ===
                                          Values.value99
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Type of stricture unknown
                                      </span>
                                    </label>
                                  </div>

                                  <div>
                                    <label className="long-text-option">
                                      <input
                                        type="checkbox"
                                        id="chk_infection"
                                        name="chk_infection"
                                        checked={
                                          transplantDetails.chk_infection
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Infection
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_bacteremia_bloodstream_infection"
                                        name="chk_bacteremia_bloodstream_infection"
                                        checked={
                                          transplantDetails.chk_bacteremia_bloodstream_infection
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Bacteremia/bloodstream infection
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_abdominal_wound_infection"
                                        name="chk_abdominal_wound_infection"
                                        checked={
                                          transplantDetails.chk_abdominal_wound_infection
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Abdominal/wound infection
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_pneumonia_infection"
                                        name="chk_pneumonia_infection"
                                        checked={
                                          transplantDetails.chk_pneumonia_infection
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Pneumonia infection
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_epstein_barr_virus_infection"
                                        name="chk_epstein_barr_virus_infection"
                                        checked={
                                          transplantDetails.chk_epstein_barr_virus_infection
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Epstein–Barr virus (EBV) infection
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_cytomegalovirus_infection"
                                        name="chk_cytomegalovirus_infection"
                                        checked={
                                          transplantDetails.chk_cytomegalovirus_infection
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Cytomegalovirus (CMV) infection
                                      </span>
                                    </label>
                                  </div>
                                  <div className="radio-text-padding margin-align">
                                    <label>
                                      <input
                                        type="radio"
                                        id="rbl_type_infection_unknown"
                                        name="rbl_type_infection_unknown"
                                        value={99}
                                        checked={
                                          transplantDetails.rbl_type_infection_unknown ===
                                          Values.value99
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Type of infection unknown
                                      </span>
                                    </label>
                                  </div>

                                  <div className="option-without-input">
                                    <label className="optn-fbox">
                                      <input
                                        type="checkbox"
                                        id="chk_post_operative_complications_other"
                                        name="chk_post_operative_complications_other"
                                        checked={
                                          transplantDetails.chk_post_operative_complications_other
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span>Other, please specify: </span>
                                      {/* <input
                                        className="input-dash "
                                        type="text"
                                        id="txt_post_operative_complications"
                                        name="txt_post_operative_complications"
                                        value={
                                          transplantDetails.txt_post_operative_complications
                                        }
                                        onChange={HandleFieldChange}
                                        maxLength={300}
                                      /> */}
                                      {/* <textarea
                                         type="text"
                                         id="txt_post_operative_complications"
                                         name="txt_post_operative_complications"
                                         value={
                                          transplantDetails.txt_post_operative_complications
                                         }
                                        onChange={HandleFieldChange}
                                        maxLength={300}
                                        style={{
                                          display: "flex",
                                          marginTop: "4px",
                                        }}
                                      />             */}
                                    </label>
                                    <CustomTextArea
                                      id="txt_post_operative_complications"
                                      name="txt_post_operative_complications"
                                      value={
                                        transplantDetails.txt_post_operative_complications
                                      }
                                      onChange={HandleFieldChange}
                                      styles={{ marginLeft: "30px", width: "90%" }}
                                    />
                                  </div>
                                  <div>
                                    <label className="long-text-option">
                                      <input
                                        type="radio"
                                        id="rbl_post_operative_none_of_the_above"
                                        name="rbl_post_operative_none_of_the_above"
                                        value={1}
                                        checked={
                                          transplantDetails.rbl_post_operative_none_of_the_above ===
                                          Values.value1
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        None of the above
                                      </span>
                                    </label>
                                  </div>

                                  <div>
                                    <label className="long-text-option">
                                      <input
                                        type="radio"
                                        id="rbl_post_operative_none_of_the_above99"
                                        name="rbl_post_operative_none_of_the_above"
                                        value={99}
                                        checked={
                                          transplantDetails.rbl_post_operative_none_of_the_above ===
                                          Values.value99
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={
                                    hardErrList.transplant_post_operative_complicationsEmpty
                                  }
                                  message={CommonError_Msgs.Msg1}
                                />
                              </td>
                            </tr>





                          </table>
                        </div>
                      </div>
                    </div>




                    <div>


                      <div className="block-border block-margin white-bg" style={{ marginBlock: "20px 0" }}>
                        <div>
                          <div className="question">
                            <span className="question-weight">Q24.</span>
                            <span className="quest-text-pad question-weight">
                              Please provide dates for each{" "}
                              <span
                                data-tooltip-id="encounterTip"
                                className="modal-popup"
                                onClick={() =>
                                  setShowHideHyperlinkModalTransplantVisit(true)
                                }
                              >
                                liver transplant-related visit
                              </span>
                              {showHideHyperlinkModalTransplantVisit && (
                                <InfoPopUp
                                  description={hyperlinkTextTransplantVisits}
                                  OkClick={() =>
                                    setShowHideHyperlinkModalTransplantVisit(false)
                                  }
                                />
                              )}
                              , including operating room (OR)
                              readmissions, intensive care unit (ICU)
                              (including neonatal ICU [NICU]) visits,
                              emergency room (ER) visits, and
                              hospitalizations, where the admission date occurred from the
                              LT/LKT transplant hospitalization
                              admission date (
                              <span className="indigo-text">
                                {transplantDetails.transplant_admission_dt || "transplant admission date"}
                              </span>
                              ) {" "}
                              and up to 27 months after the index date (
                              <span className="indigo-text">
                                {dates?.twenty_four_months_post_stabilization ?? " [24-month post-stabilization date]"}
                              </span>


                              ).
                            </span>
                          </div>
                          <br></br>
                          <p className="question-weight">Please include:</p>
                          <span className="note-type question-weight">
                            <ul>
                              <li>
                                All readmissions to the
                                OR, ICU/NICU, ER, or hospital related to
                                the index treatment (i.e., LT or LT as
                                part of LKT procedure); do not include a
                                row for the LT/LKT visits
                                recorded in Q17.
                              </li>
                              <li>
                                All visits related to addressing a
                                post-operative complication after the
                                LT/LKT procedure.
                              </li>
                              <li>
                                This should not include visits related to a kidney transplant or re-transplantation only; hospitalizations related to kidney transplants and re-transplants are provided in Q26.
                              </li>
                            </ul>
                          </span>
                          <p className="question-weight">
                            If multiple care settings occurred (e.g.,
                            patient transferred from ER to ICU to
                            hospital, etc.), please{" "}
                            <u>
                              list each care setting as an individual
                              row with start and end dates specific for
                              that setting of care.
                            </u>{" "}
                            Add additional rows for each
                            hospitalization, ICU/NICU visit, ER visit,
                            and OR readmission, as needed.
                          </p>
                        </div>
                        {transplantVisitDetails &&
                          transplantVisitDetails.length > 0 &&
                          transplantVisitDetails.map((data, idx) => (
                            <div key={data.transplantvisitid} className="loop-section-ul">
                              <div className="loop-head">
                                <span className="question-weight">
                                  {GetOrdinal(idx + 1)} Transplant Visit
                                </span>
                                {idx !== 0 && (
                                  <div className="delete-btn-div">
                                    <img
                                      width="16px"
                                      src="../Assets/images/Icon-material-delete.png"
                                      alt=""
                                      onClick={() =>
                                        DeleteTransplantVisitRow(idx)
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                              <div className="containertd grid-overflow" colSpan={3}>
                                <table
                                  style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}
                                  className="borderTable borderTable-custom"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        className="table-th-sec"
                                      >
                                        Admission date of visit{" "}
                                        <span className="indigo-text"></span>
                                      </th>
                                      <th
                                        className="table-th-sec"
                                      >
                                        Discharge date of visit{" "}
                                        <span className="indigo-text"></span>
                                      </th>
                                      <th
                                        className="table-th-sec"
                                        style={{
                                          border: "1px solid",
                                          borderColor: "inherit",
                                          padding: "8px",
                                          textAlign: "center",
                                          minWidth: "360px",
                                        }}
                                      >
                                        Visit type{" "}
                                        <span className="indigo-text"></span>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        className="containertd"
                                        style={{
                                          borderBottom: "0",
                                        }}
                                      >
                                        <>
                                          {idx === Values.value0 && (
                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_transplant_visit_admission" +
                                                    idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.rbl_transplant_visit_admission ===
                                                    1
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span>
                                                  No admissions or
                                                  readmissions occurred
                                                  during period
                                                </span>
                                              </label>
                                            </div>
                                          )}
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "rbl_transplant_visit_admission" +
                                                  idx
                                                }
                                                value={2}
                                                checked={
                                                  data.rbl_transplant_visit_admission ===
                                                  2
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />
                                              <span className="date-field-padding-left">
                                                <DateControl
                                                  ctrlId={
                                                    "transplant_visit_admission_dt-" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  date={
                                                    data.transplant_visit_admission_dt
                                                  }
                                                />
                                              </span>
                                            </label>
                                          </div>

                                          <div className="estimated-date-padding text-margin">
                                            <label>
                                              <input
                                                type="checkbox"
                                                id={idx}
                                                name={
                                                  "chk_transplant_visit_admission_est" +
                                                  idx
                                                }
                                                checked={
                                                  data.chk_transplant_visit_admission_est
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />
                                              <span className="radio-text-padding">
                                                Estimated Date
                                              </span>
                                            </label>
                                          </div>

                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "rbl_transplant_visit_admission" +
                                                  idx
                                                }
                                                value={99}
                                                checked={
                                                  data.rbl_transplant_visit_admission ===
                                                  99
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />
                                              <span className="radio-text-padding">
                                                Date Unknown
                                              </span>
                                            </label>
                                          </div>
                                          <ErrorField
                                            show={
                                              data.transplant_visit_admissionEmpty
                                            }
                                            message={
                                              CommonError_Msgs.Msg1
                                            }
                                          />
                                          <ErrorField
                                            show={
                                              data.transplant_admission_visit_dt_empty ||
                                              data.transplant_admission_visit_dt_invalid
                                            }
                                            message={
                                              CommonError_Msgs.Msg2
                                            }
                                          />
                                        </>
                                      </td>
                                      <td
                                        className="containertd"
                                        style={{
                                          borderBottom: "0",
                                        }}
                                      >
                                        {data.rbl_transplant_visit_admission ===
                                          Values.value1 ? (
                                          <p
                                            style={{
                                              textAlign: "center",
                                              marginBottom: "0"
                                            }}
                                          >
                                            <b>Not Applicable</b>
                                          </p>
                                        ) : (
                                          <>
                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_transplant_visit_discharge" +
                                                    idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.rbl_transplant_visit_discharge ===
                                                    1
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Visit is ongoing
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_transplant_visit_discharge" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={
                                                    data.rbl_transplant_visit_discharge ===
                                                    2
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="date-field-padding-left">
                                                  <DateControl
                                                    ctrlId={
                                                      "transplant_visit_discharge_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    date={
                                                      data.transplant_visit_discharge_dt
                                                    }
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div className="estimated-date-padding text-margin">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={
                                                    "chk_transplant_visit_discharge_est" +
                                                    idx
                                                  }
                                                  checked={
                                                    data.chk_transplant_visit_discharge_est
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Estimated Date
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_transplant_visit_discharge" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    data.rbl_transplant_visit_discharge ===
                                                    99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Date Unknown
                                                </span>
                                              </label>
                                              <ErrorField
                                                show={
                                                  data.transplant_visit_dischargeEmpty
                                                }
                                                message={
                                                  CommonError_Msgs.Msg1
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  data.transplant_discharge_visit_dt_empty ||
                                                  data.transplant_discharge_visit_dt_invalid
                                                }
                                                message={
                                                  CommonError_Msgs.Msg2
                                                }
                                              />
                                            </div>
                                          </>
                                        )}
                                      </td>
                                      <td className="containertd">
                                        {data.rbl_transplant_visit_admission ===
                                          Values.value1 ? (
                                          <p
                                            style={{
                                              textAlign: "center",
                                              marginBottom: "0"
                                            }}
                                          >
                                            <b>Not Applicable</b>
                                          </p>
                                        ) : (
                                          <div className="">
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_visit_type" +
                                                    idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.rbl_visit_type ===
                                                    1
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  OR readmission
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_visit_type" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={
                                                    data.rbl_visit_type ===
                                                    2
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  ICU/NICU visit
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_visit_type" +
                                                    idx
                                                  }
                                                  value={3}
                                                  checked={
                                                    data.rbl_visit_type ===
                                                    3
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  ER visit
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_visit_type" +
                                                    idx
                                                  }
                                                  value={4}
                                                  checked={
                                                    data.rbl_visit_type ===
                                                    4
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Hospitalization
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                data.visit_typeEmpty
                                              }
                                              message={
                                                CommonError_Msgs.Msg1
                                              }
                                            />
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ))}

                        {transplantVisitDetails &&
                          transplantVisitDetails[0]
                            .rbl_transplant_visit_admission !==
                          Values.value1 && patientLocked===false && (
                            <div className="sub-question-bot-sapce-ul mt-2">
                              <div className="answer-list-text">
                                <a onClick={AddTransplantVisitRow}>
                                  <img
                                    width="18px"
                                    src="../Assets/images/plus.png"
                                    alt=""
                                  />
                                </a>
                                <a
                                  onClick={AddTransplantVisitRow}
                                  className="radio-text-padding"
                                >
                                  Click here to add another transplant
                                  visit
                                </a>
                              </div>
                            </div>
                          )}

                      </div>



                      <div className="block-border block-margin white-bg" style={{ marginBlock: "20px 0" }}>
                        <div>
                          <div className="question">
                            <span className="question-weight">Q25.</span>
                            <div className="quest-text-pad question-weight"><span>
                              Provide the dates and type of any{" "}
                              <u>liver transplant rejections</u> the
                              patient experienced from the index date (
                              <span className="indigo-text">
                                {dates?.indexDt ?? "index date"}
                              </span>
                              ) until the end of follow-up (
                              <span className="indigo-text">
                                {dates?.endofFollowUpDate ?? "end of follow-up"}
                              </span>
                              )?
                            </span> &nbsp;<br />
                              <span> Add additional rows for each rejection episode, as needed.</span></div>

                          </div>
                        </div>

                        {transplantRejectionDetails &&
                          transplantRejectionDetails.length > 0 &&
                          transplantRejectionDetails.map(
                            (data, idx) => (
                              <div key={data.transplantrejectionid} className="loop-section-ul">
                                <div className="loop-head">
                                  <span className="question-weight">
                                    {GetOrdinal(idx + 1)} Transplant
                                    Rejection
                                  </span>
                                  {idx !== 0 && (
                                    <div className="delete-btn-div">
                                      <img
                                        width="16px"
                                        src="../Assets/images/Icon-material-delete.png"
                                        alt=""
                                        onClick={() =>
                                          DeleteTransplantRejectionRow(
                                            idx
                                          )
                                        }
                                      />
                                    </div>
                                  )}
                                </div>
                                <div
                                  className="containertd grid-overflow"
                                  colSpan={3}
                                >
                                  <table
                                    style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}
                                    className="borderTable borderTable-custom"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            border: "1px solid",
                                            borderColor: "inherit",
                                            padding: "8px",
                                            textAlign: "center",
                                            minWidth: "150px",
                                          }}
                                        >
                                          Rejection episode start date{" "}
                                          <span className="indigo-text"></span>
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid",
                                            borderColor: "inherit",
                                            padding: "8px",
                                            textAlign: "center",
                                            minWidth: "200px",
                                          }}
                                        >
                                          Rejection episode end date{" "}
                                          <span className="indigo-text"></span>
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid",
                                            borderColor: "inherit",
                                            padding: "8px",
                                            textAlign: "center",
                                            minWidth: "390px",
                                          }}
                                        >
                                          Type of rejection{" "}
                                          <span className="indigo-text"></span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          className="containertd"
                                          style={{
                                            borderBottom: "0",
                                          }}
                                        >
                                          <>
                                            {idx == Values.value0 && (
                                              <div className="date-field-padding">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "rbl_transplant_rejection_start" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.rbl_transplant_rejection_start ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="">
                                                    Did not experience
                                                    liver transplant
                                                    rejection
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                            <div style={{ marginTop: '4px' }}>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_transplant_rejection_start" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={
                                                    data.rbl_transplant_rejection_start ===
                                                    2
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="">
                                                  <DateControl
                                                    ctrlId={
                                                      "transplant_rejection_start_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    date={
                                                      data.transplant_rejection_start_dt
                                                    }
                                                  />
                                                </span>
                                              </label>
                                            </div>

                                            <div className="estimated-date-padding text-margin">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={
                                                    "chk_transplant_rejection_start_est" +
                                                    idx
                                                  }
                                                  checked={
                                                    data.chk_transplant_rejection_start_est
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Estimated Date
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "rbl_transplant_rejection_start" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    data.rbl_transplant_rejection_start ===
                                                    99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Date Unknown
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                data.transplant_rejection_startEmpty
                                              }
                                              message={
                                                CommonError_Msgs.Msg1
                                              }
                                            />
                                            <ErrorField
                                              show={
                                                data.transplant_rejection_start_dt_empty ||
                                                data.transplant_rejection_start_dt_invalid
                                              }
                                              message={
                                                CommonError_Msgs.Msg2
                                              }
                                            />
                                          </>
                                        </td>
                                        <td
                                          className="containertd"
                                          style={{
                                            borderBottom: "0",
                                          }}
                                        >
                                          {data.rbl_transplant_rejection_start ===
                                            Values.value1 ? (
                                            <p
                                              style={{
                                                textAlign: "center",
                                                marginBottom: "0"
                                              }}
                                            >
                                              <b>Not Applicable</b>
                                            </p>
                                          ) : (
                                            <>
                                              {/* <div className="date-field-padding">
                                                      <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "rbl_transplant_rejection_end" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.rbl_transplant_rejection_end ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span className="">
                                                            Did not experience
                                                            liver transplant
                                                            rejection
                                                          </span>
                                                        </label>
                                                      </div> */}

                                              <div style={{ marginTop: '4px' }}>
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "rbl_transplant_rejection_end" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.rbl_transplant_rejection_end ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="">
                                                    <DateControl
                                                      ctrlId={
                                                        "transplant_rejection_end_dt-" +
                                                        idx
                                                      }
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      date={
                                                        data.transplant_rejection_end_dt
                                                      }
                                                    />
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="estimated-date-padding text-margin">
                                                <label>
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "chk_transplant_rejection_end_est" +
                                                      idx
                                                    }
                                                    checked={
                                                      data.chk_transplant_rejection_end_est
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Estimated Date
                                                  </span>
                                                </label>
                                              </div>

                                              <div>
                                                <label>
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "rbl_transplant_rejection_end" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.rbl_transplant_rejection_end ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Date Unknown
                                                  </span>
                                                </label>
                                                <ErrorField
                                                  show={
                                                    data.transplant_rejection_endEmpty
                                                  }
                                                  message={
                                                    CommonError_Msgs.Msg1
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    data.transplant_rejection_end_dt_empty ||
                                                    data.transplant_rejection_end_dt_invalid
                                                  }
                                                  message={
                                                    CommonError_Msgs.Msg2
                                                  }
                                                />
                                              </div>
                                            </>
                                          )}
                                        </td>
                                        <td className="containertd">
                                          {data.rbl_transplant_rejection_start ===
                                            Values.value1 ? (
                                            <p
                                              style={{
                                                textAlign: "center",
                                                marginBottom: "0"
                                              }}
                                            >
                                              <b>Not Applicable</b>
                                            </p>
                                          ) : (
                                            <div className="">
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "rbl_rejection_type" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.rbl_rejection_type ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span>
                                                    Hyperacute rejection
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "rbl_rejection_type" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.rbl_rejection_type ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span>
                                                    Acute T-cell
                                                    mediated rejection
                                                    (TCMR)
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "rbl_rejection_type" +
                                                      idx
                                                    }
                                                    value={3}
                                                    checked={
                                                      data.rbl_rejection_type ===
                                                      3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span>
                                                    Acute anti-body
                                                    mediated rejection
                                                    (AMR)
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "rbl_rejection_type" +
                                                      idx
                                                    }
                                                    value={4}
                                                    checked={
                                                      data.rbl_rejection_type ===
                                                      4
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span>
                                                    Chronic rejection
                                                  </span>
                                                </label>
                                              </div>

                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "rbl_rejection_type" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.rbl_rejection_type ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span>
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>
                                              <ErrorField
                                                show={
                                                  data.rejection_typeEmpty
                                                }
                                                message={
                                                  CommonError_Msgs.Msg1
                                                }
                                              />
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )
                          )}

                        {transplantRejectionDetails &&
                          transplantRejectionDetails[0]
                            .rbl_transplant_rejection_start !==
                          Values.value1 && patientLocked===false && (
                            <div className="sub-question-bot-sapce-ul mt-2">
                              <div className="answer-list-text">
                                <a onClick={AddTransplantRejectionRow}>
                                  <img
                                    width="18px"
                                    src="../Assets/images/plus.png"
                                    alt=""
                                  />
                                </a>
                                <a
                                  onClick={AddTransplantRejectionRow}
                                  className="radio-text-padding"
                                >
                                  Click here to add another transplant
                                  rejection
                                </a>
                              </div>
                            </div>
                          )}



                      </div>

                      <div className="block-border block-margin white-bg" style={{ marginBlock: "20px 0" }}>
                        <div className="question">
                          <span className="question-weight">Q26.</span>
                          {lt_selected || lkt_value === Values.value1 ? (
                            <span className="quest-text-pad question-weight">
                              {/* <span className="indigo-text">
                                    [If S4= “LT” or “Combined LKT”]
                                  </span> */}
                              Please provide dates for{" "}
                              <u>
                                all kidney transplants
                                {/* and transplant-related hospitalizations */}
                              </u>
                              {/* , as applicable,  */}
                              {" "}that occurred from the index
                              date (
                              <span className="indigo-text">
                                {dates?.indexDt ?? "index date"}
                              </span>
                              ) until the end of follow-up (
                              <span className="indigo-text">
                                {dates?.endofFollowUpDate ?? "end of follow-up"}
                              </span>
                              ). Please include any kidney
                              re-transplantation procedures or procedures
                              {/* that ultimately resulted */}
                              {" "}resulting in kidney rejection. For each transplant, please provide the hospitalization admission and discharge dates for that kidney transplant.
                              Add additional rows for each kidney transplant
                              procedure, as needed.
                              
                             
                              {lt_selected ?
                              ( <p>
                                <b>Note:</b> <u>{"for patients with LT only, this should not include visits related to LT - these are provided in Q24"}</u>.
                             </p>): (
                               <p>
                               <b>Note:</b> <u>{"for patients with combined LKT, please also include the dates of the LKT hospitalization below this should be the same as Q24 and indicate that the kidney transplant was part of the LKT procedure. Add additional kidney transplants, as applicable."}</u> .
                            </p>
                             ) } 

                            </span>
                          ) 
                          :lkt_value === Values.value2 ? (

                            <div className="quest-text-pad question-weight">
                              {/* <span className="indigo-text">
                                    [If S4=“Sequential LKT”]
                                  </span> */}
                              Please provide dates for{" "}
                              <u>
                                all kidney transplant
                                {/* and ransplant-related hospitalization */}
                              </u>
                              {/* , as applicable,  */}
                              {" "}that occurred from 12 months
                              prior to the index date (
                              <span className="indigo-text">
                                {dates?.oneYr_pretransplant_start ?? "1-year pre-transplant start"}
                              </span>
                              ) until the end of follow-up (
                              <span className="indigo-text">
                                {dates?.endofFollowUpDate ?? "end of follow-up"}
                              </span>
                              ).
                              {/* Please include any kidney
                              re-transplantation procedures or procedures
                              that ultimately resulted in kidney rejection.
                              Add additional rows for each kidney transplant
                              procedure, as needed. */}
                              Please include any kidney re-transplantation procedures or procedures resulting in kidney rejection. For each transplant,
                              please provide the hospitalization admission and discharge dates for that kidney transplant. Add additional rows for each
                              kidney transplant procedure, as needed.
                              <p>
                                <b>Note:</b> the <u>dates below should be for kidney transplants only; please do not include visits related to LT previously provided in Q24</u>
                                 {/* this <u>should not include visits related to a liver transplant only; hospitalizations related to LT procedures are provided in Q24. </u> */}
                              </p>
                            </div>
                          ) : null}
                        </div>

                        {transplantHospitalizationDetails &&
                          transplantHospitalizationDetails.length > 0 &&
                          transplantHospitalizationDetails.map((data, idx) => (
                            <div key={data.transplanthospitalizationid} className="loop-section-ul">
                              <div className="loop-head">
                                <span className="question-weight">
                                  {GetOrdinal(idx + 1)} Transplant-related Hospitalization
                                </span>
                                {idx !== 0 && (
                                  <div className="delete-btn-div">
                                    <img
                                      width="16px"
                                      src="../Assets/images/Icon-material-delete.png"
                                      alt=""
                                      onClick={() =>
                                        DeleteTransplantHospitalizationRow(idx)
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                              <div className="containertd grid-overflow">
                                <table
                                  style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}
                                  className="borderTable"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        className="table-th-sec"
                                      // style={{
                                      //   border: "1px solid",
                                      //   borderColor: "inherit",
                                      //   padding: "8px",
                                      //   textAlign: "center",
                                      //   minWidth: "230px",
                                      // }}
                                      >
                                        Date of transplant{" "}
                                        <span className="indigo-text"></span>
                                      </th>
                                      <th
                                        className="table-th-sec"
                                      // style={{
                                      //   border: "1px solid",
                                      //   borderColor: "inherit",
                                      //   padding: "8px",
                                      //   textAlign: "center",
                                      //   minWidth: "230px",
                                      // }}
                                      >
                                        Kidney transplant hospitalization
                                        admission date{" "}

                                      </th>
                                      <th
                                        className="table-th-sec"
                                      // style={{
                                      //   border: "1px solid",
                                      //   borderColor: "inherit",
                                      //   padding: "8px",
                                      //   textAlign: "center",
                                      //   minWidth: "230px",
                                      // }}
                                      >
                                        Kidney transplant hospitalization
                                        discharge date{" "}

                                      </th>
                                      <th
                                        className="table-th-sec"
                                      // style={{
                                      //   border: "1px solid",
                                      //   borderColor: "inherit",
                                      //   padding: "8px",
                                      //   textAlign: "center",
                                      //   minWidth: "120px",
                                      // }}
                                      >
                                        Part of LKT{" "}

                                      </th>
                                      <th
                                        // style={{
                                        //   border: "1px solid",
                                        //   borderColor: "inherit",
                                        //   padding: "8px",
                                        //   textAlign: "center",
                                        //   minWidth: "140px",
                                        // }}
                                        className="table-th-sec"
                                      >
                                        Donor type{" "}

                                      </th>
                                      <th
                                        // style={{
                                        //   border: "1px solid",
                                        //   borderColor: "inherit",
                                        //   padding: "8px",
                                        //   textAlign: "center",
                                        //   minWidth: "150px",
                                        // }}
                                        className="table-th-sec"
                                      >
                                        Procedure type{" "}

                                      </th>
                                      <th
                                        // style={{
                                        //   border: "1px solid",
                                        //   borderColor: "inherit",
                                        //   padding: "8px",
                                        //   textAlign: "center",
                                        //   minWidth: "120px",
                                        // }}
                                        className="table-th-sec"
                                      >
                                        Kidney location{" "}

                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        className="containertd"
                                        style={{
                                          borderBottom: "0",
                                        }}
                                      >
                                        <>

                                          {idx == Values.value0 && (
                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_transplant_hospitalization" + idx}
                                                  value={1}
                                                  checked={
                                                    data.rbl_transplant_hospitalization === Values.value1}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span>
                                                  Patient did not undergo a kidney
                                                  transplant
                                                </span>
                                              </label>
                                            </div>
                                          )}

                                          <div className="option-without-input">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"rbl_transplant_hospitalization" + idx}
                                              value={2}
                                              checked={
                                                data.rbl_transplant_hospitalization === Values.value2}
                                              onChange={HandleRepeaterFieldChange}
                                            />
                                            <span
                                              style={{
                                                marginLeft: "15px",
                                              }}
                                            >
                                              <DateControl
                                                ctrlId={
                                                  "transplant_hospitalization_dt-" +
                                                  idx
                                                }
                                                HandleDateChange={
                                                  HandleRepeaterDateChange
                                                }
                                                date={
                                                  data.transplant_hospitalization_dt
                                                }
                                              />
                                            </span>
                                          </div>
                                          <div className="estimated-date-padding text-margin">
                                            <label>
                                              <input
                                                type="checkbox"
                                                id={idx}
                                                name={
                                                  "chk_transplant_hospitalization_est" +
                                                  idx
                                                }
                                                checked={
                                                  data.chk_transplant_hospitalization_est
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />
                                              <span className="radio-text-padding">
                                                Estimated Date
                                              </span>
                                            </label>
                                          </div>

                                          <div>
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"rbl_transplant_hospitalization" + idx}
                                                value={99}
                                                checked={
                                                  data.rbl_transplant_hospitalization === Values.value99}
                                                onChange={HandleRepeaterFieldChange}
                                              />
                                              <span>
                                                Patient underwent kidney transplant but date Unknown
                                              </span>
                                            </label>
                                          </div>

                                          <ErrorField
                                            show={
                                              data.rbl_transplant_hospitalizationEmpty
                                            }
                                            message={
                                              CommonError_Msgs.Msg1
                                            }
                                          />
                                          <ErrorField
                                            show={
                                              data.transplant_hospitalization_dt_empty ||
                                              data.transplant_hospitalization_dt_invalid
                                            }
                                            message={
                                              CommonError_Msgs.Msg2
                                            }
                                          />
                                        </>
                                      </td>

                                      <td
                                        className="containertd"
                                        style={{
                                          borderBottom: "0",
                                        }}
                                      >
                                        {data.rbl_transplant_hospitalization ===
                                          Values.value1 ? (
                                          <p
                                            style={{
                                              textAlign: "center",
                                              marginBottom: "0"
                                            }}
                                          >
                                            <b>Not Applicable</b>
                                          </p>
                                        ) : (
                                          <>

                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_transplant_kidney_admission" + idx}
                                                  value={1}
                                                  checked={
                                                    data.rbl_transplant_kidney_admission === Values.value1}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="date-field-padding-left">
                                                  <DateControl
                                                    ctrlId={
                                                      "transplant_kidney_admission_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    date={
                                                      data.transplant_kidney_admission_dt
                                                    }
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div className="estimated-date-padding text-margin">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={
                                                    "chk_transplant_kidney_admission_est" +
                                                    idx
                                                  }
                                                  checked={
                                                    data.chk_transplant_kidney_admission_est
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Estimated Date
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_transplant_kidney_admission" + idx}
                                                  value={99}
                                                  checked={
                                                    data.rbl_transplant_kidney_admission === Values.value99}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Date Unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={
                                                data.transplant_kidney_admissionEmpty
                                              }
                                              message={
                                                CommonError_Msgs.Msg1
                                              }
                                            />
                                            <ErrorField
                                              show={
                                                data.transplant_kidney_admission_dt_empty ||
                                                data.transplant_kidney_admission_dt_invalid
                                              }
                                              message={
                                                CommonError_Msgs.Msg2
                                              }
                                            />

                                          </>
                                        )}
                                      </td>

                                      <td
                                        className="containertd"
                                        style={{
                                          borderBottom: "0",
                                        }}
                                      >
                                        {data.rbl_transplant_hospitalization ===
                                          Values.value1 ? (
                                          <p
                                            style={{
                                              textAlign: "center",
                                              marginBottom: "0"
                                            }}
                                          >
                                            <b>Not Applicable</b>
                                          </p>
                                        ) : (
                                          <>
                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_transplant_kidney_discharge" + idx}
                                                  value={1}
                                                  checked={
                                                    data.rbl_transplant_kidney_discharge === Values.value1}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="date-field-padding-left">
                                                  <DateControl
                                                    ctrlId={
                                                      "transplant_kidney_discharge_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    date={
                                                      data.transplant_kidney_discharge_dt
                                                    }
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div className="estimated-date-padding text-margin">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={
                                                    "chk_transplant_kidney_discharge_est" +
                                                    idx
                                                  }
                                                  checked={
                                                    data.chk_transplant_kidney_discharge_est
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Estimated Date
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_transplant_kidney_discharge" + idx}
                                                  value={99}
                                                  checked={
                                                    data.rbl_transplant_kidney_discharge === Values.value99}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Date Unknown
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                data.transplant_kidney_dischargeEmpty
                                              }
                                              message={
                                                CommonError_Msgs.Msg1
                                              }
                                            />
                                            <ErrorField
                                              show={
                                                data.transplant_kidney_discharge_dt_empty ||
                                                data.transplant_kidney_discharge_dt_invalid
                                              }
                                              message={
                                                CommonError_Msgs.Msg2
                                              }
                                            />
                                          </>
                                        )}
                                      </td>

                                      <td className="containertd">
                                        {data.rbl_transplant_hospitalization ===
                                          Values.value1 ? (
                                          <p
                                            style={{
                                              textAlign: "center",
                                              marginBottom: "0"
                                            }}
                                          >
                                            <b>Not Applicable</b>
                                          </p>
                                        ) : (
                                          <div className="">
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_part_lkt" + idx}
                                                  value={1}
                                                  checked={
                                                    data.rbl_part_lkt === Values.value1}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Yes
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_part_lkt" + idx}
                                                  value={0}
                                                  checked={
                                                    data.rbl_part_lkt === Values.value0}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  No
                                                </span>
                                              </label>
                                            </div>

                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_part_lkt" + idx}
                                                  value={99}
                                                  checked={
                                                    data.rbl_part_lkt === Values.value99}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                data.part_lktEmpty
                                              }
                                              message={
                                                CommonError_Msgs.Msg1
                                              }
                                            />

                                          </div>
                                        )}
                                      </td>

                                      <td className="containertd">
                                        {data.rbl_transplant_hospitalization ===
                                          Values.value1 ? (
                                          <p
                                            style={{
                                              textAlign: "center",
                                              marginBottom: "0"
                                            }}
                                          >
                                            <b>Not Applicable</b>
                                          </p>
                                        ) : (
                                          <div className="">
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_donor_type" + idx}
                                                  value={1}
                                                  checked={
                                                    data.rbl_donor_type === Values.value1}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Same as LT
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_donor_type" + idx}
                                                  value={2}
                                                  checked={
                                                    data.rbl_donor_type === Values.value2}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Living
                                                </span>
                                              </label>
                                            </div>

                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_donor_type" + idx}
                                                  value={3}
                                                  checked={
                                                    data.rbl_donor_type === Values.value3}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Deceased
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_donor_type" + idx}
                                                  value={99}
                                                  checked={
                                                    data.rbl_donor_type === Values.value99}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                data.transplant_donor_typeEmpty
                                              }
                                              message={
                                                CommonError_Msgs.Msg1
                                              }
                                            />
                                          </div>
                                        )}
                                      </td>

                                      <td className="containertd">
                                        {data.rbl_transplant_hospitalization ===
                                          Values.value1 ? (
                                          <p
                                            style={{
                                              textAlign: "center",
                                              marginBottom: "0"
                                            }}
                                          >
                                            <b>Not Applicable</b>
                                          </p>
                                        ) : (
                                          <div className="">
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_procedure_type" + idx}
                                                  value={1}
                                                  checked={
                                                    data.rbl_procedure_type === Values.value1}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Single kidney
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_procedure_type" + idx}
                                                  value={2}
                                                  checked={
                                                    data.rbl_procedure_type === Values.value2}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Dual kidney
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_procedure_type" + idx}
                                                  value={99}
                                                  checked={
                                                    data.rbl_procedure_type === Values.value99}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                data.transplant_procedure_typeEmpty
                                              }
                                              message={
                                                CommonError_Msgs.Msg1
                                              }
                                            />
                                          </div>
                                        )}
                                      </td>

                                      <td className="containertd">
                                        {data.rbl_procedure_type ===
                                          Values.value1 && data.rbl_transplant_hospitalization !== 1 ? (
                                          <div className="">
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_kidney_location" + idx}
                                                  value={1}
                                                  checked={
                                                    data.rbl_kidney_location === Values.value1}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Left
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_kidney_location" + idx}
                                                  value={2}
                                                  checked={
                                                    data.rbl_kidney_location === Values.value2}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Right
                                                </span>
                                              </label>
                                            </div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"rbl_kidney_location" + idx}
                                                  value={99}
                                                  checked={
                                                    data.rbl_kidney_location === Values.value99}
                                                  onChange={HandleRepeaterFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                data.transplant_kidney_locationEmpty
                                              }
                                              message={
                                                CommonError_Msgs.Msg1
                                              }
                                            />
                                          </div>

                                        ) : (

                                          <p
                                            style={{
                                              textAlign: "center",
                                              marginBottom: "0"
                                            }}
                                          >
                                            <b>Not Applicable</b>
                                          </p>
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ))}

                        {transplantHospitalizationDetails &&
                          transplantHospitalizationDetails[0]
                            .rbl_transplant_hospitalization !==
                          Values.value1 && patientLocked===false && (
                            <div className="sub-question-bot-sapce-ul mt-2">
                              <div className="answer-list-text">
                                <a onClick={AddTransplantHospitalizationRow}>
                                  <img
                                    width="18px"
                                    src="../Assets/images/plus.png"
                                    alt=""
                                  />
                                </a>
                                <a
                                  onClick={AddTransplantHospitalizationRow}
                                  className="radio-text-padding"
                                >
                                  Click here to add another transplant
                                  hospitalization
                                </a>
                              </div>
                            </div>
                          )}





                      </div>

                    </div>
                  </div>

                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TransplantCharacteristics;
